// Wallet.js
import React, { lazy, Suspense, useDeferredValue, useEffect, useState, useContext, useCallback, useRef, useMemo } from "react";
import { Chart } from 'primereact/chart';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import { Dropdown } from 'primereact/dropdown';
import { ProgressBar } from 'primereact/progressbar';
import { Button } from 'primereact/button';
import { Skeleton } from 'primereact/skeleton';
import { Badge } from '@nextui-org/react';

import { ScrollPanel } from 'primereact/scrollpanel';

import ContractContext from '../../ContractContext';
import {
    miniCardHeaderStyle, miniInfoStyle, infoStyle,
} from "./TileStyles";
import { getTokenLogo, formatCurrencyExtended, abbreviateNumber, getTokenPrice, formatWalletAddress, formatPercentage, formatDecimals, generateColorPalette, areMapsEqual } from '../../utils';
import BigNumber from 'bignumber.js';
import TokenSelectorModal from './TokenSelectorModal';
import LpManageModal from './LpManageModal';
import { useWeb3React } from "@web3-react/core";
import Web3 from "web3";
import HTTPProvider from "web3";
import { Card as NextCard, Switch, TabView, TabPanel } from "@nextui-org/react";
import { Button as NextButton, Loading } from "@nextui-org/react";
import { Dialog } from 'primereact/dialog';
import RewardsPending from './RewardsPending';
import RadarCharts from "./RadarCharts";
import { TabView as PrimeTabView, TabPanel as PrimeTabPanel } from 'primereact/tabview';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import axios from 'axios';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';  // USD icon
import CurrencyBitcoinIcon from '@mui/icons-material/CurrencyBitcoin';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import RadarIcon from '@mui/icons-material/Radar';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import BarChartIcon from '@mui/icons-material/BarChart';
import PrivacyIcon from '@mui/icons-material/PrivacyTip';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import IconButton from '@mui/material/IconButton';
//import TinyRadarChart from './TinyRadarChart';
//import NewTinyRadarChart from "./NewTinyRadarChart";
import TinyHolderCharts from "./TinyHolderCharts";
import HolderCharts from "./HolderCharts"
import ArbiScanSwapButton from "./ArbiScanSwapButton";
import LpPerformance from "./LpPerformance";
import QuickSwap from "./QuickSwap";
import SmartArbiSwap from "./SmartArbiSwap";
import { Panel } from 'primereact/panel';
import { syncMultiplePairs } from "./multiPairSync";
import { MultiSelect } from 'primereact/multiselect';
import pairAbi from "../../contracts/pairAbi";
import liquidityOracleAbi from "../../contracts/liquidityOracleAbi";
// Import toast from react-toastify
import { toast } from 'react-toastify';

// Correctly import the ERC20 ABI
import ierc20Abi from "../../contracts/ierc20Abi";


// Import pLimit for concurrency control
import pLimit from 'p-limit';
import { color } from "@mui/system";

import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';
import { format } from "url";
import { use } from "react";

const UpIcon = () => <ArrowUpwardIcon style={{ color: 'green', marginLeft: '5px' }} />;
const DownIcon = () => <ArrowDownwardIcon style={{ color: 'red', marginLeft: '5px' }} />;

const TOKEN_FETCH_CONCURRENCY = 50;  
const tokenLimiter = pLimit(TOKEN_FETCH_CONCURRENCY);

const TinyRadarChart   = lazy(() => import("./TinyRadarChart"));
const NewTinyRadarChart = lazy(() => import("./NewTinyRadarChart"));

export async function fetchLpStats(lpToken, web3, tokenSelections) {
    const { pairAddress } = lpToken;
    if (!pairAddress) return lpToken;

    try {
        const pairContract = new web3.eth.Contract(pairAbi, pairAddress);

        // Get token0, token1 addresses from the pair
        const token0Address = await pairContract.methods.token0().call();
        const token1Address = await pairContract.methods.token1().call();

        // Get reserves
        const { _reserve0, _reserve1 } = await pairContract.methods.getReserves().call();

        // For decimals/prices, consult your tokenSelections
        const token0Data = tokenSelections.find(t => t.value.toLowerCase() === token0Address.toLowerCase());
        const token1Data = tokenSelections.find(t => t.value.toLowerCase() === token1Address.toLowerCase());

        const token0Decimals = token0Data?.decimals || 18;
        const token1Decimals = token1Data?.decimals || 18;
        const token0Price = token0Data?.price || 0;
        const token1Price = token1Data?.price || 0;

        // Convert reserves to big numbers
        const reserve0 = new BigNumber(_reserve0).div(new BigNumber(10).pow(token0Decimals));
        const reserve1 = new BigNumber(_reserve1).div(new BigNumber(10).pow(token1Decimals));

        // TVL in USD
        const tvlUSD = reserve0.times(token0Price).plus(reserve1.times(token1Price));

        // Total supply of the LP token
        const totalSupplyLPWei = await pairContract.methods.totalSupply().call();
        const totalSupplyLP = new BigNumber(totalSupplyLPWei).div(new BigNumber(10).pow(lpToken.decimals || 18));

        // LP token price in USD
        const lpTokenPrice = totalSupplyLP.gt(0)
            ? tvlUSD.div(totalSupplyLP)
            : new BigNumber(0);

        // Your share in the pool
        const userLpBalanceBN = new BigNumber(lpToken.lpTokenBalance || 0);
        const yourShareOfPool = userLpBalanceBN.div(totalSupplyLP).times(100);

        // Your LP value in USD
        const yourLpUSDValue = userLpBalanceBN.times(lpTokenPrice);




        // 1) Dex data for token0
        const token0Dex = await getDexscreenerData(token0Address);
        //console.log("token0Dex", token0Dex);
        // token0Dex = { pairs: [...], totalVolume24h: 12345 }

        // 2) Dex data for token1
        const token1Dex = await getDexscreenerData(token1Address);
        //console.log("token1Dex", token1Dex);
        // 3) Find the DexScreener pair that has a matching "pairAddress" (the LP address).
        // Usually DexScreener uses pair "baseToken_address" but they do store "pairAddress" or "liquidityPoolAddress" in their JSON.

        function findPairVolume(dexResponse, ourPairAddress) {
            if (!dexResponse || !Array.isArray(dexResponse.pairs)) return 0;

            // Attempt to find a DexScreener pair that exactly matches `ourPairAddress`
            const matchingPair = dexResponse.pairs.find(
                (p) => p.pairAddress?.toLowerCase() === ourPairAddress.toLowerCase()
            );

            // If found, return its 24h volume
            return matchingPair?.volume?.h24 ? Number(matchingPair.volume.h24) : 0;
        }

        // We'll check token0Dex, then token1Dex, and pick whichever is non-zero
        const token0PairVolume = findPairVolume(token0Dex, pairAddress);
        const token1PairVolume = findPairVolume(token1Dex, pairAddress);

        // Decide which volume to use (maybe add them, or pick the bigger one, or whichever is found)
        const dailyVolumeUSD = token0PairVolume > 0 ? token0PairVolume : token1PairVolume;

        // PancakeSwap fee is ~0.17%. 
        const dailyFeesUSD = dailyVolumeUSD * 0.0017;
        let dailyAPR = tvlUSD.gt(0)
            ? (dailyFeesUSD / tvlUSD.toNumber())
            : 0;

        // If dailyAPR is not a valid finite number, set it to 0
        if (isNaN(dailyAPR) || !isFinite(dailyAPR)) {
            dailyAPR = 0;
        }

        const annualAPR = dailyAPR * 365;

        // For daily APR in % form, 
        // (dailyAPR=1 means 1% daily, so dailyAPR/100=0.01):
        const annualAPY = (Math.pow(1 + dailyAPR, 365) - 1);
        return {
            ...lpToken,
            token0Address,
            token1Address,
            token0Price,
            token1Price,
            reserve0: reserve0.toNumber(),
            reserve1: reserve1.toNumber(),
            tvlUSD: tvlUSD.toNumber(),
            lpTokenPrice: lpTokenPrice.toNumber(),
            yourShareOfPool: yourShareOfPool.toNumber(),
            yourLpUSDValue: yourLpUSDValue.toNumber(),
            // approximate APY
            dailyVolumeUSD,
            dailyAPR,
            annualAPR,
            annualAPY,
        };
    } catch (err) {
        console.error("Error fetching LP stats:", err);
        return lpToken; // fallback
    }
}

const fetchCharting_General_Quick = async (tokenAddress, timeFrame) => {
    try {
        const response = await axios.get(`https://radar-defi-api.onrender.com/history/chart/price/${tokenAddress}/${timeFrame}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching charting data for token ${tokenAddress}:`, error);
        return []; // Return default values in case of an error
    }
};

const fetchDexscreenerData = async (tokenAddress) => {
    try {
        const response = await axios.get(`https://api.dexscreener.com/latest/dex/tokens/${tokenAddress}`);
        const pairs = response.data.pairs || [];

        // Aggregate the h24 volume from all pairs
        const totalVolume24h = pairs.reduce((acc, pair) => {
            const volume = new BigNumber(pair.volume?.h24 || 0);
            return acc.plus(volume);
        }, new BigNumber(0));

        const totalBuys24h = pairs.reduce((acc, pair) => {
            const buys = new BigNumber(pair.txns?.h24?.buys || 0);
            return acc.plus(buys);
        }, new BigNumber(0));

        const totalSells24h = pairs.reduce((acc, pair) => {
            const sells = new BigNumber(pair.txns?.h24?.sells || 0);
            return acc.plus(sells);
        }, new BigNumber(0));

        // Calculate average price change over h24
        const totalPriceChange24h = pairs.reduce((acc, pair) => {
            const priceChange = new BigNumber(pair.priceChange?.h24 || 0);
            return acc.plus(priceChange);
        }, new BigNumber(0));

        const averagePriceChange24h = pairs.length > 0 ? totalPriceChange24h.dividedBy(pairs.length).toNumber() : 0;

        return {
            pairs: pairs,
            volume24h: totalVolume24h.toNumber(),
            totalBuys24h: totalBuys24h.toNumber(),
            totalSells24h: totalSells24h.toNumber(),
            averagePriceChange24h: averagePriceChange24h
        };
    } catch (error) {
        console.error(`Error fetching Dexscreener data for token ${tokenAddress}:`, error);
        return {
            volume24h: 0,
            totalBuys24h: 0,
            totalSells24h: 0,
            averagePriceChange24h: 0
        }; // Return default values in case of an error
    }
};


const dexscreenerCache = new Map();

// Function to get Dexscreener data with caching
const getDexscreenerData = async (tokenAddress) => {
    const cacheEntry = dexscreenerCache.get(tokenAddress.toLowerCase());
    const oneHour = 60 * 60 * 1000;
    const now = Date.now();

    if (cacheEntry && (now - cacheEntry.timestamp) < oneHour) {
        return cacheEntry.data;
    }

    const data = await fetchDexscreenerData(tokenAddress);
    dexscreenerCache.set(tokenAddress.toLowerCase(), { data, timestamp: now });
    return data;
};

const chartingCache = new Map();

// Function to get charting data with caching
const getChartingDataQuick = async (tokenAddress, timeFrame) => {
    const cacheKey = `${tokenAddress}_${timeFrame}`;
    const cacheEntry = chartingCache.get(cacheKey);
    const oneHour = 60 * 60 * 1000;
    const now = Date.now();

    if (cacheEntry && (now - cacheEntry.timestamp) < oneHour) {
        return cacheEntry.data;
    }

    const data = await fetchCharting_General_Quick(tokenAddress, timeFrame);
    chartingCache.set(cacheKey, { data, timestamp: now });
    return data;
};

const getStepSize = (value) => {
    const stepSizes = [1, 5, 10, 25, 50, 100, 250, 500, 1000, 5000, 10000, 50000, 100000, 500000];

    // Iterate through the step sizes and select the first one that is less than 1/5 of the value
    for (let i = 0; i < stepSizes.length; i++) {
        if (value / 5 <= stepSizes[i]) {
            return stepSizes[i];
        }
    }

    // If no suitable step size is found, return the largest available step size
    return stepSizes[stepSizes.length - 1];
};


const token_categories = {
    "Rewards": [
        "0x6e61579c22f9a6da63a33e819f29b6697d2a126e",
        "0x5d5dc8e4d680fc3ef33986292eb02315ab05c735",
        "0x5097FccD1E58fC18717c6bFc8Ca0E6dc0e006758",
        "0xC486312D5158315C7Bbe2C353ad565d1A9d1f0de",
        "0x5d5dC8e4D680FC3eF33986292eB02315ab05c735",
        "0xA11b53C5ecA5AFcb9eB8e7E60260721c4f398279",
        "0x0cab564f58ad72877f0bc3cd52468860294c15a6",
        "0x904B4224acA463666E98f21cC8C54f8D423f6648",
        "0x27874A586bafaF54d4Cd0aae368ad9569D06d115",
        "0x350494Bcc94EfB5c6080f6A6F0043da27be2AD2C",
        "0xF59918B07278ff20109f8c37d7255e0677B45c43",
        "0x17f1B7F7d9BB1D17CE01561Dc4DE658d4C343910",
        "0x689cC7BB716AfF448DcA16a8b61253C7E246D9Fc",
        "0x5Ae89b52f6B5D25EBA50f0441F91A81968689D95",
        "0x4e90fe9d6C26b5DafF55b69a00197b5601cADd68",
        "0x237FA37Be83955C62d852B16516e6F4407bf3945",
        "0xA341E745078035D6d19E2F2B518DE31f29b2a1bE",
        "0x27579772186072590bf9Cb909af6B9E7B8153412",
        "0xF79F112Ee5F75F618919efB1C2E29cA3e4381322",
        "0xC001BBe2B87079294C63EcE98BdD0a88D761434e",
        "0x942e4B2De5BA499181b390daD4CAe8e0A27c606b",
        "0x651a89fed302227d41425235F8E934502FB94C48",
        "0x59803e5Fe213D4B22fb9b061c4C89E716a1CA760",
        "0xF33893DE6eB6aE9A67442E066aE9aBd228f5290c",
        "0x7B86f5ca09Dc00502E342b0FeF5117E1c32222Ce",
        "0xe7057B10E2B59F46D151588d9C8694B4b8328F44",
        "0x11F331c62AB3cA958c5212d21f332a81c66F06e7",
        "0x3a91A88Ef4bB813BB99EF5a745bcb56e3A3b403b",
        "0x3C2e501B08CF5C16061468c96b19b32bae451dA3",
        "0x606379220AB266bBE4b0FeF8469e6E602f295a84",
        "0x3297abAe220272b79A134FEA9B1CdA413a6d95F4",
        "0xAA16492d95F80E488aC997933abE7aa45D838aDa",
        "0x5A341DCF49e161CC73591f02e5f8CDE8A29733fb",
        "0x988F7c894e4001EEB7B570CDE80dffE21CF7B6B9",
        "0x14220f5893e945EeD36389905b991d6b972e04f0",
        "0xC17c30e98541188614dF99239cABD40280810cA3",
        "0x61Efb60A075479D96Ad3D1C54dd87D71AfFF980f",
        "0xf82007D28B8D0EaFC6Fde42eCb697A74824D839E",
        "0xc50F00779559b2E13Dee314530cC387CC5dD85ae",
        "0x1A6423EB373a6C0644BB69D0CC8BcBB87F4Ee2F5",
        "0x74a45AAa6B1bbc1dBbD16662FC6a0d3B8364c24f",
        "0x1E653794A6849bC8A78be50C4D48981AfAD6359d",
        "0xa94D583e4Ea69216b870A6300a9f717bB6D4a076",
    ],
    "Blue Chip": [
        "0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c",
        "0x2170Ed0880ac9A755fd29B2688956BD959F933F8",
        "0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c",
        "0x1D2F0da169ceB9fC7B3144628dB156f3F6c60dBE",
        "0x570A5D26f7765Ecb712C0924E4De545B89fD43dF",
        "0x3EE2200Efb3400fAbB9AacF31297cBdD1d435D47",
        "0xF8A0BF9cF54Bb92F17374d9e9A321E6a111a51bD",
        "0xbA2aE424d960c26247Dd6c32edC70B295c744C43",
        "0xCE7de646e7208a4Ef112cb6ed5038FA6cC6b12e3",
        "0x7083609fCE4d1d8Dc0C979AAb8c869Ea2C873402",
        "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
        "0x76A797A59Ba2C17726896976B7B3747BfD1d220f",
        "0x156ab3346823B651294766e23e6Cf87254d68962",
        "0x56b6fB708fC5732DEC1Afc8D8556423A2EDcCbD6",
        "0xBf5140A22578168FD562DCcF235E5D43A02ce9B1",
        "0x3d6545b08693daE087E957cb1180ee38B9e3c25E",
        "0xc5f0f7b66764F6ec8C8Dff7BA683102295E16409",
        "0xAD6cAEb32CD2c308980a548bD0Bc5AA4306c6c18",
    ],
    "Arbitrage": [
        "0x6e61579c22f9a6da63a33e819f29b6697d2a126e",
        "0x5097FccD1E58fC18717c6bFc8Ca0E6dc0e006758",
        "0xA11b53C5ecA5AFcb9eB8e7E60260721c4f398279",
        "0x83b27De2Fca046FA63a11C7Ce7743DE33Ec58822",
        "0x30807D3b851A31d62415B8bb7Af7dCa59390434a",
    ],
    "Stable": [
        "0x324E8E649A6A3dF817F97CdDBED2b746b62553dD",
        "0x27874A586bafaF54d4Cd0aae368ad9569D06d115",
        "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56",
        "0x2e3B6906B976AB8Da82228e0569B3ef6ea1e8Cc6",
        "0xCC42724C6683B7E57334c4E856f4c9965ED682bD",
        "0x55d398326f99059fF775485246999027B3197955",
        "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d",
    ],
    "Ultra": [
        "0x0cab564f58ad72877f0bc3cd52468860294c15a6",
        "0x904B4224acA463666E98f21cC8C54f8D423f6648",
        "0xb014728C841D8Ccca6C236fE04B274D206cc60D0",
        "0x09b22c55436cb5F4F91306e632e0a5F0DD031BA8",
        "0x2761c609f3DbA79FFb34d28ab8d9cc2FF381fD3A",
        "0x0Cab564F58AD72877F0bc3Cd52468860294c15a6",
        "0x3834303483f139c26bc282528aDee6b7Da103D54",
        "0xDfD077c9C2F488e5CFeD14EbBcb7B8E056334EbA",
        "0x2a5D78825Bf470e70f9B62F2BCE8483941c11132",
    ],
    "Meme": [
        "0x2859e4544C4bB03966803b044A93563Bd2D0DD4D",
        "0xbA2aE424d960c26247Dd6c32edC70B295c744C43",
        "0x6894CDe390a3f51155ea41Ed24a33A4827d3063D",
        "0xA697e272a73744b343528C3Bc4702F2565b2F422",
        "0xF79F112Ee5F75F618919efB1C2E29cA3e4381322",
        "0xc748673057861a797275CD8A068AbB95A902e8de",
        "0xdfBEA88C4842d30c26669602888d746D30F9D60d",
        "0x136331f3bE5b0F32Fb21a7f19d1D4C47F0671494",
        "0xfb5B838b6cfEEdC2873aB27866079AC55363D37E",
        "0xD74b782E05AA25c50e7330Af541d46E18f36661C",
        "0x7bd6FaBD64813c48545C9c0e312A0099d9be2540",
        "0xC3afDe95B6Eb9ba8553cDAea6645D45fB3a7FAF5",
        "0xfEbe8C1eD424DbF688551D4E2267e7A53698F0aa",
        "0xd8Fa690304D2B2824D918C0c7376e2823704557A",
        "0xE4FAE3Faa8300810C835970b9187c268f55D998F",
        "0x77B65A2e95Aa76eB40e7684847E78aAAaE345Cf3",
        "0x25d887Ce7a35172C62FeBFD67a1856F20FaEbB00",
        "0x2eB4b89C37F25648dE6e0e416aafD13c17F2F046",
        "0x3d36685D91b060FB0351401f27eE058311fB00C1",
        "0x1A6423EB373a6C0644BB69D0CC8BcBB87F4Ee2F5",
        "0x1E653794A6849bC8A78be50C4D48981AfAD6359d",
        "0x988300f65191C3a52Ef59DBB5539C01b502787a9",
        "0x8b1869f79b9abF52001314A2E6990A96F039058D",
        "0xFd54E565e6de7509B07CDBa5769178045F212530",
        "0x76B560b628F74BF192bE09F0449abef8e456BE79",
        "0xED6AF21Df463c7f116A6d7d687A4c190c4cf7586",

    ],
    "Cross-Chain": [
        "0x3b5D979AEeb193F812392c4082D70eE99244085D",
        "0xfE642F7463b7A2aB67690209ED5A070a46b66064",
    ],
    "Adult": [
        "0x27Ae27110350B98d564b9A3eeD31bAeBc82d878d",
    ],
    "Other": [
        "0x8Ea2f890CB86DFb0E376137451c6fD982AFefc15",
        "0x6FDcdfef7c496407cCb0cEC90f9C5Aaa1Cc8D888",
        "0x68F483B06F1E96B10239e333b598f145Da8571c2",
        "0xfE642F7463b7A2aB67690209ED5A070a46b66064",
        "0x8FFf93E810a2eDaaFc326eDEE51071DA9d398E83",
        "0x425f027eD04f5D1660C8dd78652B32c015C0362e",
        "0x88CE0d545cF2eE28d622535724B4A06E59a766F0",
        "0xb0688E82D162Df5288A0D986DfFd4CF80AFb7897",
        "0x0420EB45AC5a4f04763f679c07c3A637741E0289",
        "0x156df0dd6300C73ac692D805720967cf4464776e",
        "0x69B0af16FDd2E80968eb505cd41DC26efb2B80BF",
        "0x7da07fB98F16c26a6417ca5627719194a6944211",
        "0xe4Cc45Bb5DBDA06dB6183E8bf016569f40497Aa5",
        "0x55Be3e1F81Fc6d5169882339EcC0Fb8460f91de1",
        "0xc6DdDB5bc6E61e0841C54f3e723Ae1f3A807260b",
        "0x74AFe449D1BEFfc90456CfEbD700AB391abD7DAF",
        "0x4B0F1812e5Df2A09796481Ff14017e6005508003",
        "0xD41FDb03Ba84762dD66a0af1a6C8540FF1ba5dfb",
        "0x19cd9B8e42d4EF62c3EA124110D5Cfd283CEaC43",
        "0x0Eb3a705fc54725037CC9e008bDede697f62F335",
        "0x965F527D9159dCe6288a2219DB51fc6Eef120dD1",
        "0x1Ba42e5193dfA8B03D15dd1B86a3113bbBEF8Eeb",
        "0x9840652DC04fb9db2C43853633f0F62BE6f00f98",
        "0xeCbcE2c13d3A1248deBfD23DCc0558b495916756",
        "0x1Fa4a73a3F0133f0025378af00236f3aBDEE5D63",
        "0x5f0Da599BB2ccCfcf6Fdfd7D81743B6020864350",
        "0x0F1cBEd8EFa0E012AdbCCB1638D0aB0147D5Ac00",
        "0x4545D603CE79F4Db3485989aa7413eA85D48D10b",
        "0xBBB58d64195CaAfF61857b98a3177ba851CB8572",
        "0xA7536D3C8b307f9c208eC84B54af0e38A4839A5e",
        "0xb7Ae4eA886fAcE39D47a47f46D6AfAbcaAd5AF6E",
        "0x2456BBAD80BfAD346AecEa45fA38C81a6963132D",
    ]
};

const RadarChartComponent = React.memo(({ walletHoldings, token_categories }) => {
    // Compute total wallet value
    const totalWalletValue = useMemo(() => {
        return walletHoldings.reduce((acc, token) => acc + token.balanceUSD, 0);
    }, [walletHoldings]);

    // Compute sum per category
    const categorySums = useMemo(() => {
        const sums = {};
        const categorizedTokens = new Set();

        // Calculate sums for defined categories
        for (const [category, addresses] of Object.entries(token_categories)) {
            const categoryTotal = walletHoldings
                .filter(token => addresses.includes(token.address.toLowerCase()))
                .reduce((acc, token) => {
                    categorizedTokens.add(token.address.toLowerCase());
                    return acc + token.balanceUSD;
                }, 0);

            if (categoryTotal > 0) {
                sums[category] = categoryTotal;
            }
        }

        // Calculate sums for tokens that are not in any category (i.e., "Other" category)
        const otherTotal = walletHoldings
            .filter(token => !categorizedTokens.has(token.address.toLowerCase()))
            .reduce((acc, token) => acc + token.balanceUSD, 0);

        if (otherTotal > 0) {
            sums["Other"] = otherTotal;
        }

        return sums;
    }, [walletHoldings, token_categories]);

    // Radar chart data
    const data = useMemo(() => ({
        labels: Object.keys(categorySums),
        datasets: [{
            label: 'Category Sum Value (USD)',
            data: Object.values(categorySums),
            backgroundColor: 'rgba(54, 162, 235, 0.4)',
            borderColor: 'rgba(54, 162, 235, 1)',
            pointBackgroundColor: 'rgba(54, 162, 235, 1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(54, 162, 235, 1)',
            borderWidth: 2,
        }]
    }), [categorySums]);

    // Radar chart options
    const options = useMemo(() => {
        const stepSize = totalWalletValue > 0 ? getStepSize(totalWalletValue) : 20;

        return {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                r: {
                    grid: {
                        color: 'rgba(255, 255, 255, 0.1)',
                    },
                    angleLines: {
                        color: 'rgba(255, 255, 255, 0.2)',
                    },
                    pointLabels: {
                        color: '#fff',
                        font: {
                            size: 14,
                            family: 'Arial, sans-serif',
                        },
                    },
                    beginAtZero: true,
                    max: totalWalletValue > 0 ? totalWalletValue : 100,
                    ticks: {
                        backdropColor: 'transparent',
                        color: '#fff',
                        stepSize: stepSize,
                        font: {
                            size: 12,
                            family: 'Arial, sans-serif',
                        },
                        callback: function (value) {
                            return `${formatCurrencyExtended(value)}`;
                        },
                    },
                },
            },
            plugins: {
                legend: {
                    display: true,
                    labels: {
                        color: '#fff',
                        font: {
                            size: 14,
                            family: 'Arial, sans-serif',
                        },
                    },
                },
                tooltip: {
                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                    titleFont: {
                        size: 14,
                        family: 'Arial, sans-serif',
                        weight: 'bold',
                    },
                    bodyFont: {
                        size: 12,
                        family: 'Arial, sans-serif',
                    },
                    callbacks: {
                        label: (context) => {
                            // Use `context.raw` to access the actual value
                            const value = context.raw;
                            return `${context.label}: ${formatCurrencyExtended(value)}`;
                        },
                    },
                },
            },
        };
    }, [totalWalletValue]);

    return (
        <div style={{ maxWidth: '500px', margin: '20px auto', padding: '20px', backgroundColor: '#1e1e1e', borderRadius: '15px' }}>
            <h4 style={{ textAlign: 'center', color: '#fff', marginBottom: '20px' }}>Holdings by Type</h4>
            <div style={{ height: '400px' }}>
                <Chart type="radar" data={data} options={options} />
            </div>
        </div>
    );
});




// Memoize the TokenInfoModal to prevent unnecessary re-renders
// Updated TokenInfoModal with DataTable and Pagination
const TokenInfoModal = React.memo(({ token, onClose, fetchTokenDetails, maximize, bnbPrice, tokenSelections }) => {
    const [activeTab, setActiveTab] = useState(0);
    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };
    const { account, library } = useWeb3React();
    const [loadingDetails, setLoadingDetails] = useState(!token?.liquidityPairs || token.liquidityPairs.length === 0);
    const [liquidityPairs, setLiquidityPairs] = useState(token?.liquidityPairs || []);
    const [recentTransfers, setRecentTransfers] = useState([]);
    const [selectedPairIndex, setSelectedPairIndex] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);
    const rowsPerPage = 10;

    const [sortField, setSortField] = useState('lpShare'); // Currently sorted field
    const [sortOrder, setSortOrder] = useState(-1); // 1 for ascending, -1 for descending
    const [loadingTransfers, setLoadingTransfers] = useState(false);
    const [loadingProgress, setLoadingProgress] = useState(0);

    const [selectedTimeRange, setSelectedTimeRange] = useState("7d");
    const [currentPageTransfers, setCurrentPageTransfers] = useState(1);
    const itemsPerPageTransfers = 10; // Adjust the number of items per page as needed

    //load from cache use account address + token address as key
    const [activeIndex, setActiveIndex] = useState(0);

    // Calculate total pages based on the length of recentTransfers
    const totalPagesTransfers = Math.ceil(recentTransfers?.length / itemsPerPageTransfers);

    // Slice the array to show only the transfers for the current page
    const paginatedTransfers = recentTransfers?.slice(
        (currentPageTransfers - 1) * itemsPerPageTransfers,
        currentPageTransfers * itemsPerPageTransfers
    );

    const liquidityTableRef = useRef(null);
    const transfersTableRef = useRef(null);

    useEffect(() => {
        // Reset to first page when the time range changes
        setCurrentPageTransfers(1);
    }, [selectedTimeRange]);

    useEffect(() => {
        // If liquidity pairs are not provided, fetch them
        if (loadingDetails) {
            (async () => {
                try {
                    const fetchedToken = await fetchTokenDetails(token);
                    //console.log("Fetched token details:", fetchedToken);
                    setLiquidityPairs(fetchedToken.liquidityPairs);
                } catch (error) {
                    console.error("Error fetching liquidity pairs:", error);
                } finally {
                    setLoadingDetails(false);
                }
            })();
        }
    }, [token, loadingDetails]);

    // Process liquidityPairs to calculate total backing and percentages
    const processLiquidityData = useCallback((pairs) => {
        if (!pairs || pairs.length === 0) return { labels: [], data: [], tableData: [] };
        const totalBacking = pairs.reduce((acc, pair) => acc + Number(pair.tokenBalanceInLiquidityPair), 0);

        const labels = pairs.map(pair => `${pair.dexName}: ${pair.tokenSymbol}/${pair.backingTokenSymbol}`);
        const data = pairs.map(pair => (Number(pair.tokenBalanceInLiquidityPair) / totalBacking) * 100);

        // Generate table data with required fields
        const tableData = pairs.map((pair, index) => ({
            pair: `${pair.tokenSymbol}/${pair.backingTokenSymbol}`,
            dexName: pair.dexName,
            lpShare: (data[index] || 0),
            index, // Keep track of the original index for synchronization
            backingTokenBalanceInLiquidityPair: pair.backingTokenBalanceInLiquidityPair,
            tokenBalanceInLiquidityPair: pair.tokenBalanceInLiquidityPair,
            backingTokenSymbol: pair.backingTokenSymbol,
            tokenSymbol: pair.tokenSymbol,
            tokenAddress: token.address,
            backingTokenAddress: pair.backingTokenAddress,
            tokenDecimals: token.decimals,
            lpTokenValueInBnb: pair.lpTokenValueInBnb,
        }));

        return { labels, data, tableData };
    }, []);


    const chartData = useMemo(() => processLiquidityData(liquidityPairs), [liquidityPairs]);

    const tableData = useMemo(() => chartData.tableData, [chartData]);

    // Generate dynamic colors based on number of entries
    const chartColors = useMemo(() => generateColorPalette(chartData.labels.length), [chartData.labels.length]);

    // Prepare chart data with dynamic colors
    const chartDataMemo = useMemo(() => ({
        labels: chartData.labels,
        datasets: [{
            data: chartData.data,
            backgroundColor: chartColors,
            hoverBackgroundColor: chartColors.map(color => {
                // Lighten the color for hover effect
                const [h, s, l] = color.match(/\d+/g).map(Number);
                return `hsl(${h}, ${s}%, ${Math.min(l + 10, 100)}%)`;
            })
        }]
    }), [chartData, chartColors]);

    // Chart options with custom legend handling
    const chartOptions = useMemo(() => ({
        plugins: {
            legend: {
                display: false
            },
            tooltip: {
                callbacks: {
                    label: (context) => `${context.label}: ${context.parsed.toFixed(2)}%`
                }
            }
        },
        onClick: (e, elements) => {
            if (elements.length > 0) {
                const index = elements[0].index;
                setSelectedPairIndex(index);
                // Navigate to the corresponding page in the table
                const newPage = Math.floor(index / rowsPerPage);
                setCurrentPage(newPage);
            }
        },
        responsive: true,
        maintainAspectRatio: false,
        elements: {
            arc: {
                borderWidth: 0, // Remove border from the slices
            }
        }
    }), [rowsPerPage]);

    // Pagination Controls
    const onPageChange = (event) => {
        setCurrentPage(event.page);
        setSelectedPairIndex(null); // Deselect chart when page changes
    };
    // Create a sorted version of tableData based on sortField and sortOrder
    const sortedTableData = useMemo(() => {
        if (!sortField) return tableData; // If no sort field is selected, return original data

        const sorted = [...tableData].sort((a, b) => {
            let valueA = a[sortField];
            let valueB = b[sortField];

            // If sorting by lpShare, convert to float for numerical comparison
            if (sortField === 'lpShare') {
                valueA = parseFloat(valueA);
                valueB = parseFloat(valueB);
            }

            if (valueA < valueB) return sortOrder === 1 ? -1 : 1;
            if (valueA > valueB) return sortOrder === 1 ? 1 : -1;
            return 0;
        });

        return sorted;
    }, [tableData, sortField, sortOrder]);


    // Define DataTable's sliced data based on current page
    const paginatedLiquidityPairs = useMemo(() => {
        const start = currentPage * rowsPerPage;
        const end = start + rowsPerPage;
        return sortedTableData.slice(start, end);
    }, [sortedTableData, currentPage, rowsPerPage]);


    // Handle table row selection
    const onRowSelect = (e) => {
        const index = e.index + currentPage * rowsPerPage;
        setSelectedPairIndex(index);
    };

    // Highlight selected slice in the chart
    const chartPlugins = useMemo(() => [{
        beforeDraw: (chart) => {
            if (selectedPairIndex !== null && chartData.data[selectedPairIndex] !== undefined) {
                const ctx = chart.ctx;
                const meta = chart.getDatasetMeta(0);
                const arc = meta.data[selectedPairIndex];
                ctx.save();
                ctx.beginPath();
                arc.draw(ctx);
                ctx.lineWidth = 2;
                ctx.strokeStyle = '#000';
                ctx.stroke();
                ctx.restore();
            }
        }
    }], [selectedPairIndex, chartData.data]);

    const GetLatestBlockNumber = async (web3) => {
        const latestBlock = await web3.eth.getBlock("latest");
        return latestBlock.number;
    };

    const getTimeRangeStartingBlock = async (timeRange, web3) => {
        const currentBlock = await GetLatestBlockNumber(web3);
        let blocksToGoBack;
        const BLOCKS_PER_DAY = 24 * 60 * 60 / 3; // BSC block time ~3 seconds

        switch (timeRange) {
            case '7d': blocksToGoBack = 7 * BLOCKS_PER_DAY; break;
            case '30d': blocksToGoBack = 30 * BLOCKS_PER_DAY; break;
            case '3m': blocksToGoBack = 90 * BLOCKS_PER_DAY; break;
            case '6m': blocksToGoBack = 180 * BLOCKS_PER_DAY; break;
            case '9m': blocksToGoBack = 270 * BLOCKS_PER_DAY; break;
            case '1y': blocksToGoBack = 365 * BLOCKS_PER_DAY; break;
            case 'all': blocksToGoBack = 15000000; break;
            default: blocksToGoBack = 7 * BLOCKS_PER_DAY;
        }

        return Math.max(currentBlock - blocksToGoBack, 0);
    };

    const fetchTransferEvents = useCallback(async () => {
        // if (!token?.address) return;
        // setLoadingTransfers(true);
        // setLoadingProgress(0);
        // try {
        //     const web3 = new Web3("https://bsc-rpc.publicnode.com");
        //     const tokenContract = new web3.eth.Contract(ierc20Abi, token.address);
        //     const currentBlock = await GetLatestBlockNumber(web3);
        //     const fromBlock = await getTimeRangeStartingBlock(selectedTimeRange, web3);
        //     const totalBlocksToFetch = currentBlock - fromBlock;
        //     const maxBlocks = 10000;
        //     const totalChunks = Math.ceil(totalBlocksToFetch / maxBlocks);
        //     const promises = [];

        //     let completedChunks = 0;
        //     for (let offset = 0; offset < totalBlocksToFetch; offset += maxBlocks) {
        //         const chunkFromBlock = Math.max(fromBlock + offset, 0);
        //         const chunkToBlock = Math.min(fromBlock + offset + maxBlocks, currentBlock);
        //         promises.push(
        //             tokenContract.getPastEvents('Transfer', { fromBlock: chunkFromBlock, toBlock: chunkToBlock })
        //                 .then(events => {
        //                     completedChunks += 1;
        //                     setLoadingProgress(Math.min((completedChunks / totalChunks) * 100, 100));
        //                     return events;
        //                 })
        //         );
        //     }

        //     const allEventsArray = await Promise.all(promises);
        //     const allEvents = [].concat.apply([], allEventsArray);
        //     const sortedEvents = allEvents.sort((a, b) => b.blockNumber - a.blockNumber);
        //     setRecentTransfers(sortedEvents);
        // } catch (error) {
        //     console.error("Error fetching transfer events:", error);
        //     //toast.error("Failed to fetch transfer events.");
        // } finally {
        //     setLoadingTransfers(false);
        // }
    }, [token, selectedTimeRange]);

    useEffect(() => {
        if (activeIndex === 1 && token?.address) {
            fetchTransferEvents();
        }
    }, [token, selectedTimeRange, fetchTransferEvents, activeIndex]);


    const handleTimeRangeChange = (event) => {
        setSelectedTimeRange(event.target.value);
    };

    const exportLiquidityCSV = useCallback(() => {
        if (liquidityTableRef.current) {
            liquidityTableRef.current.exportCSV();
        }
    }, []);

    const exportLiquidityExcel = useCallback(() => {
        if (liquidityTableRef.current) {
            const data = sortedTableData.map(row => ({
                Pair: row.pair,
                DEX: row.dexName,
                'Share (%)': row.lpShare,
            }));
            const worksheet = XLSX.utils.json_to_sheet(data);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "LiquiditySummary");
            XLSX.writeFile(workbook, `${token.symbol}_LiquiditySummary.xlsx`);
        }
    }, [sortedTableData, token.symbol]);

    const exportLiquidityPDF = useCallback(() => {
        if (liquidityTableRef.current) {
            const doc = new jsPDF();
            doc.text(`${token.symbol} Liquidity Summary`, 14, 16);
            const tableColumn = ["Pair", "DEX", "Share (%)"];
            const tableRows = sortedTableData.map(row => [
                row.pair,
                row.dexName,
                row.lpShare,
            ]);
            doc.autoTable({
                startY: 20,
                head: [tableColumn],
                body: tableRows,
            });
            doc.save(`${token.symbol}_LiquiditySummary.pdf`);
        }
    }, [sortedTableData, token.symbol]);


    const exportTransfersCSV = useCallback(() => {
        if (transfersTableRef.current) {
            transfersTableRef.current.exportCSV();
        }
    }, []);

    const exportTransfersExcel = useCallback(() => {
        if (transfersTableRef.current) {
            const data = recentTransfers.map(event => ({
                From: formatWalletAddress(event.returnValues.from),
                To: formatWalletAddress(event.returnValues.to),
                Value: formatDecimals(event.returnValues.value, token.decimals),
                Transaction: event.transactionHash,
                Block: event.blockNumber,
            }));
            const worksheet = XLSX.utils.json_to_sheet(data);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "RecentTransfers");
            XLSX.writeFile(workbook, `${token.symbol}_RecentTransfers.xlsx`);
        }
    }, [recentTransfers, token.decimals, token.symbol]);

    const exportTransfersPDF = useCallback(() => {
        if (transfersTableRef.current) {
            const doc = new jsPDF();
            doc.text(`${token.symbol} Recent Transfers`, 14, 16);
            const tableColumn = ["From", "To", "Value", "Transaction", "Block"];
            const tableRows = recentTransfers.map(event => [
                formatWalletAddress(event.returnValues.from),
                formatWalletAddress(event.returnValues.to),
                formatDecimals(event.returnValues.value, token.decimals),
                event.transactionHash,
                event.blockNumber,
            ]);
            doc.autoTable({
                startY: 20,
                head: [tableColumn],
                body: tableRows,
            });
            doc.save(`${token.symbol}_RecentTransfers.pdf`);
        }
    }, [recentTransfers, token.decimals, token.symbol]);

    const header = () => {
        return (
            <div style={{
                display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '3px', marginLeft: '5px', marginRight: '5px',
                fontSize: '11px', color: "white", borderRadius: "10px"
            }}>
                <div><strong>Name:</strong> {token?.name}</div>
                <div><strong>Symbol:</strong> {token?.symbol}</div>
                <div><strong>Decimals:</strong> {token?.decimals}</div>
                <div><strong>Address:</strong> {formatWalletAddress(token?.address)}</div>
                <div><strong>Total Supply:</strong> {formatDecimals(token?.totalSupply, token?.decimals)}</div>
                <div><strong>Price:</strong> {formatCurrencyExtended(token?.price)}</div>
            </div>
        );
    }

    const [selectedPairAddresses, setSelectedPairAddresses] = useState(liquidityPairs?.[0] ? [liquidityPairs?.[0]?.pairAddress] : []);

    useEffect(() => {
        const styleId = 'dexscreener-embed-styles';
        if (!document.getElementById(styleId)) {
            const style = document.createElement('style');
            style.id = styleId;
            style.innerHTML = `
                /* Dexscreener Embed Styles */
                .dexscreener-embed {
                    position: relative;
                    width: 100%;
                    /* Remove padding-bottom and use aspect-ratio */
                    aspect-ratio: 16 / 9; /* Default aspect ratio */
                }
    
                @media (min-width: 1400px) {
                    .dexscreener-embed {
                        aspect-ratio: 16 / 8; /* Wider aspect ratio for larger screens */
                    }
                }
    
                .dexscreener-embed iframe {
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    top: 0;
                    left: 0;
                    border: 0;
                }
    
                /* Responsive Grid Container */
                .dexscreener-charts-container {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
                    gap: 10px;
                    margin: 10px 0;
                }
    
                /* Optional: Adjust iframe height on smaller screens */
                @media (max-width: 600px) {
                    .dexscreener-embed {
                        aspect-ratio: 4 / 3; /* Taller aspect ratio for mobile */
                    }
                }
            `;
            document.head.appendChild(style);
        }
    }, []);



    const renderDexCharts = () => {
        return (
            <div className="dexscreener-charts-container">
                {selectedPairAddresses.map((pairAddress) => (
                    <div key={pairAddress} className="dexscreener-embed">
                        <iframe
                            src={`https://dexscreener.com/bsc/${pairAddress}?embed=1&loadChartSettings=0&info=0&chartLeftToolbar=0&chartDefaultOnMobile=1&chartTheme=dark&theme=dark&chartStyle=1&chartType=usd&interval=60`}
                            allowFullScreen
                            title={`DEXScreener Trading Chart for ${pairAddress}`}
                            style={{
                                width: '100%',
                                height: '800px', // Fixed height causing excessive tallness
                            }}
                        ></iframe>
                    </div>
                ))}
            </div>
        );
    };


    const pairOptions = useMemo(() => {
        //console.log(liquidityPairs);
        return liquidityPairs?.map(pair => ({
            value: pair?.pairAddress,
            label: `${pair?.dexName}: ${pair?.tokenSymbol}/${pair?.backingTokenSymbol}`,
        }));
    }, [liquidityPairs]);




    return (
        <Dialog
            header={header()}
            visible={true}
            onHide={onClose}
            style={{ borderRadius: '15px', width: '800px' }}
            maximizable
            maximized={maximize}
            modal={false}
        >
            <div style={{
                //padding: '10px',
                fontFamily: 'Arial, sans-serif', color: '#333'
            }}>
                {loadingDetails ? (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
                        <ProgressBar mode="indeterminate" style={{ width: '50%' }} />
                    </div>
                ) : (
                    <div
                        style={{
                            marginLeft: '-15px',
                            marginRight: '-15px',
                        }}
                    >



                        {/* TabView */}
                        <PrimeTabView
                            activeIndex={activeIndex}
                            onTabChange={(e) => setActiveIndex(e.index)}
                            renderActiveOnly={true}
                        >

                            <PrimeTabPanel header="Charts">
                                <MultiSelect
                                    value={selectedPairAddresses}
                                    options={pairOptions}
                                    onChange={(e) => setSelectedPairAddresses(e.value)}
                                    optionLabel="label"
                                    placeholder="Select Pair Addresses"
                                    display="chip"
                                    style={{ width: '100%', marginBottom: '10px' }}
                                />
                                {renderDexCharts()}
                            </PrimeTabPanel>


                            {/* Liquidity Summary Tab */}
                            <PrimeTabPanel header="Liquidity Summary" >
                                {liquidityPairs?.length > 0 && (
                                    <>
                                        {/* <h4>Liquidity Pair Breakdown</h4> */}
                                        <div style={{ maxHeight: '400px', maxWidth: '100%', position: 'relative' }}>
                                            <Chart
                                                type="pie"
                                                data={chartDataMemo}
                                                options={chartOptions}
                                                plugins={chartPlugins}
                                            />
                                        </div>

                                        <h5 style={{ marginTop: '20px' }}>Liquidity Pairs</h5>
                                        {/* <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px', gap: '10px' }}>
                                    <Button
                                        label="Export CSV"
                                        icon="pi pi-file"
                                        onClick={exportLiquidityCSV}
                                        className="p-button-secondary p-button-sm"
                                    />
                                    <Button
                                        label="Export Excel"
                                        icon="pi pi-file-excel"
                                        onClick={exportLiquidityExcel}
                                        className="p-button-success p-button-sm"
                                    />
                                    <Button
                                        label="Export PDF"
                                        icon="pi pi-file-pdf"
                                        onClick={exportLiquidityPDF}
                                        className="p-button-danger p-button-sm"
                                    />
                                </div> */}
                                        <div style={{
                                            marginLeft: '-15px',
                                            marginRight: '-15px',
                                        }}>
                                            <DataTable
                                                value={paginatedLiquidityPairs}
                                                paginator={false}
                                                selectionMode="single"
                                                selection={selectedPairIndex !== null ? tableData[selectedPairIndex] : null}
                                                onSelectionChange={(e) => {
                                                    const selectedRow = e.value;
                                                    const globalIndex = tableData.findIndex(row => row.pair === selectedRow.pair && row.dexName === selectedRow.dexName);
                                                    setSelectedPairIndex(globalIndex);
                                                }}
                                                onSort={(e) => {
                                                    setSortField(e.sortField);
                                                    setSortOrder(e.sortOrder); // 1 for ascending, -1 for descending
                                                }}
                                                sortField={sortField}
                                                sortOrder={sortOrder}
                                                className="p-datatable-sm"
                                                size="small"
                                                style={{
                                                    minHeight: '300px',
                                                    fontSize: '10px',

                                                }}
                                                rows={rowsPerPage}
                                            >
                                                <Column field="pair" header="Pair" sortable frozen={true}></Column>
                                                <Column field="dexName" header="DEX" sortable></Column>
                                                <Column field="lpShare" header="Share (%)" sortable></Column>


                                                <Column
                                                    field="totalTokenInPair"
                                                    header={`Total ${paginatedLiquidityPairs[0]?.tokenSymbol || 'Token'} In Pair`}
                                                    sortable
                                                    body={(rowData) => {
                                                        const tokenAddress = rowData.token?.toLowerCase();
                                                        const isBackingToken = rowData.backingToken?.toLowerCase() !== tokenAddress;
                                                        const tokenBalanceInLiquidityPair = new BigNumber(
                                                            isBackingToken ? rowData.backingTokenBalanceInLiquidityPair : rowData.tokenBalanceInLiquidityPair || 0
                                                        );
                                                        const tokenDecimals = isBackingToken ? rowData.backingTokenDecimals : rowData.tokenDecimals;
                                                        return formatDecimals(tokenBalanceInLiquidityPair, tokenDecimals || 18);
                                                    }}
                                                />
                                                <Column
                                                    field="totalBackingTokenInPair"
                                                    header={`Total Backing In Pair`}
                                                    sortable
                                                    body={(rowData) => {
                                                        const tokenAddress = rowData.token?.toLowerCase();
                                                        const isBackingToken = rowData.backingToken?.toLowerCase() !== tokenAddress;
                                                        const backingTokenBalanceInLiquidityPair = new BigNumber(
                                                            isBackingToken ? rowData.tokenBalanceInLiquidityPair : rowData.backingTokenBalanceInLiquidityPair || 0
                                                        );
                                                        const backingTokenDecimals = isBackingToken ? rowData.tokenDecimals : rowData.backingTokenDecimals;
                                                        return formatDecimals(backingTokenBalanceInLiquidityPair, backingTokenDecimals || 18);
                                                    }}
                                                />
                                                {/* <Column
                                                field="lpTokenValueUSD"
                                                header="LP Token Value (USD)"
                                                sortable
                                                body={(rowData) => {
                                                    const lpValueBNB = new BigNumber(rowData.lpTokenValueInBnb || 0).dividedBy(new BigNumber(10).pow(18)); // Converts from Wei
                                                    const lpValueUSD = lpValueBNB.times(bnbPrice);
                                                    return lpValueUSD.isNaN() ? 'N/A' : formatCurrencyExtended(lpValueUSD);
                                                }}
                                            /> */}

                                            </DataTable>

                                        </div>
                                        {/* Pagination */}
                                        <Paginator
                                            first={currentPage * rowsPerPage}
                                            rows={rowsPerPage}
                                            totalRecords={sortedTableData?.length}
                                            onPageChange={onPageChange}
                                            className="p-paginator-sm p-mt-2"
                                        />
                                    </>
                                )}
                                {!liquidityPairs.length && <p>No liquidity pairs available.</p>}
                            </PrimeTabPanel>





                        </PrimeTabView>

                    </div>
                )}
            </div>
        </Dialog>
    );
});


const miniTokenCardStyle = (advancedView) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignContent: 'start',
    width: '100%',
    padding: advancedView ? '6px' : '4px',
    //outline: '1px solid grey',
    backgroundPosition: '0px 0px, 115% 50%, 0px 0px',
    backgroundSize: 'auto, auto 135%, auto',
    borderRadius: advancedView ? '15px' : '5px',
    backgroundRepeat: 'repeat, repeat-y, repeat',
    backgroundAttachment: 'scroll, scroll, scroll',
    color: 'black',
    // marginTop: '10px',
    // marginBottom: '10px',
});

const lpTokenCardStyle = (images) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignContent: 'start',
    width: '100%',
    padding: '12px',
    backgroundImage: `linear-gradient(263deg, rgb(255 255 255 / 85%), rgb(255 255, 255 / 85%)), linear-gradient(153deg,rgb(255, 255, 255), rgb(255, 255, 255) 19%, rgb(255, 255, 255))`,
    backgroundColor: 'white',
    outline: '1px solid grey',
    backgroundPosition: '0px 0px, 115% 50%, 0px 0px',
    backgroundSize: 'auto, auto 135%, auto',
    borderRadius: '15px',
    backgroundRepeat: 'repeat, repeat-y, repeat',
    backgroundAttachment: 'scroll, scroll, scroll',
    color: 'black',
    //marginTop: '10px',
    //marginBottom: '10px',
});

const containerStyle = {
    maxWidth: '1200px',
    margin: '0 auto',
    width: '100%',
    padding: '0 10px',
};

const LoadingSmallContent = () => <Skeleton width="50%" height="12px" className="mb-2" />;
const LoadingContent = () => <Skeleton width="50%" height="35px" className="mb-2" />;
const LoadingTitle = () => <Skeleton width="25%" height="25px" className="mb-2" />;



// Calculate Market Cap
const calculateMarketCap = (totalSupply, decimals, price) => {
    return new BigNumber(totalSupply)
        .div(new BigNumber(10).pow(decimals))
        .times(price)
        .toFixed(2); // Use toFixed for rounding and keeping it as a string for now
};

// Calculate LP Share %
const calculateLPShare = (holderBalance, totalSupply) => {
    if (totalSupply === '0') return '0';
    const share = new BigNumber(holderBalance).dividedBy(new BigNumber(totalSupply));
    return share;
};


// Calculate USD value for each token
const calculateTokenBalanceUSD = (token) => {
    if (!token.price || token.balanceOfHolder <= 0) return 0;
    const calculatedBalance = new BigNumber(token.balanceOfHolder)
        .times(token.price)
        .div(new BigNumber(10).pow(token.decimals));

    return calculatedBalance.isNaN() ? 0 : calculatedBalance.toNumber();
};

// Calculate total wallet balance in USD
const calculateTotalWalletBalanceUSD = (tokensListRp, bnbBalance, includeAllTokens) => {
    let totalWallet = new BigNumber(0);

    if (tokensListRp) {
        tokensListRp.forEach(token => {
            if (token.price && (token.balanceOfHolder > 0 || (token.label === "WBNB" && bnbBalance > 0))) {
                const value = new BigNumber(token.label === "WBNB" ? bnbBalance : token.balanceOfHolder)
                    .times(token.price)
                    .div(new BigNumber(10).pow(token.decimals));

                if (includeAllTokens || value.toNumber() > 1)
                    totalWallet = totalWallet.plus(value);
            }
        });
    }

    // Convert back to a number, for display
    return totalWallet.isNaN() ? 0 : totalWallet.toNumber();
};

// Calculate USD balance for BNB specifically
const calculateBNBBalanceUSD = (token, bnbBalance) => {
    if (!bnbBalance) return 0;
    const calculatedBalance = new BigNumber(bnbBalance)
        .times(token.price)
        .div(new BigNumber(10).pow(token.decimals));

    return calculatedBalance.isNaN() ? 0 : calculatedBalance.toNumber();
};

const LpTokenCard = React.memo(({ lpToken, showSkeleton, onApproxUsdValueChange, handleLpTokenCardClick, usdView, advancedView, privacyMode, tokenSelections, pressable = true, getTokenLogoUrl, radarView, imageReferences, contracts }) => {

  const { account, library } = useWeb3React();
    //console.log("LP Token, ", lpToken);
    const [decimals, setDecimals] = React.useState(null);

    React.useEffect(() => {
        let isMounted = true;
        const web3 = new Web3("https://bsc-rpc.publicnode.com");
        const tokenContract = new web3.eth.Contract(ierc20Abi, lpToken.token);

        tokenContract.methods.decimals().call()
            .then(result => {
                if (isMounted) setDecimals(parseInt(result, 10));
            })
            .catch(err => console.error("Error fetching decimals:", err));

        return () => { isMounted = false; };
    }, [lpToken.token]);



    // Look up prices
    const mainTokenData = tokenSelections.find(t => t.value.toLowerCase() === lpToken.token.toLowerCase());
    const backingTokenData = tokenSelections.find(t => t.value.toLowerCase() === lpToken.backingToken.toLowerCase());

    const mainTokenPrice = mainTokenData?.price || 0;
    const backingTokenPrice = backingTokenData?.price || 0;

    // Calculate approximate USD value of user's LP share
    const userShareFraction = (lpToken.lpShare || 0) / 100;

    const tokenBalanceBn = new BigNumber(lpToken.tokenBalanceInLiquidityPair || 0);
    const backingBalanceBn = new BigNumber(lpToken.backingTokenBalanceInLiquidityPair || 0);

    const yourTokenShare = tokenBalanceBn.times(userShareFraction);
    const yourBackingShare = backingBalanceBn.times(userShareFraction);

    const yourTokenShareUSD = yourTokenShare
        .div(new BigNumber(10).pow(decimals))
        .times(mainTokenPrice);

    const yourBackingShareUSD = yourBackingShare
        .div(new BigNumber(10).pow(lpToken.backingTokenDecimals || 18))
        .times(backingTokenPrice);

    const approxUsdValue = yourTokenShareUSD.plus(yourBackingShareUSD);

    //lpToken.approxUsdValue = approxUsdValue.toNumber();
    useEffect(() => {
        // If you only want to notify when the component mounts or if 
        // approxUsdValue changes, you can do:
        onApproxUsdValueChange(lpToken, approxUsdValue.toNumber());
    }, [lpToken, approxUsdValue, onApproxUsdValueChange]);

    lpToken.tokenDecimals = decimals;

    // Display the main LP balance and, in parentheses, the approximate USD value (if usdView is off)
    // If usdView is true, we primarily show USD, but as requested, we want to show both.
    // Let's follow "My Wallet" style:
    // Top line: show either USD or token amount, and next to it (in parentheses) the other value.
    const displayMainValue = usdView
        ? formatCurrencyExtended(approxUsdValue.toNumber())
        : formatDecimals(lpToken.lpTokenBalance, lpToken.decimals);

    const displaySecondaryValue = usdView
        ? formatDecimals(lpToken.lpTokenBalance, lpToken.decimals)
        : formatCurrencyExtended(approxUsdValue.toNumber());

    if (showSkeleton) {
        return <Skeleton style={{ width: '100%', height: '120px' }} />;
    }

    if (decimals === null) {
        return <LoadingSmallContent />;
    }
    return (
        <div>
            <NextCard
                key={lpToken.pairAddress.toLowerCase()}
                isHoverable={true}
                isPressable={pressable || !radarView}
                onClick={() => handleLpTokenCardClick(lpToken)}
                style={{
                    borderRadius: '5px',
                    padding: '4px',
                    background: 'white',
                    color: 'black',
                }}
            >
                <NextCard.Body style={{ padding: '1px' }}>
                    {/* Header row similar to My Wallet */}
                    <div style={{
                        display: 'flex', flexDirection: 'column',
                    }}>

                        <div style={{
                            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                            overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'
                        }}>
                            <div style={{ display: 'flex', flexDirection: 'row', gap: '5px', alignItems: 'center', fontWeight: 'bold' }}>
                                <img src={lpToken.tokenLogo} alt={lpToken.tokenSymbol} style={{ width: '25px', height: '25px', borderRadius: '50%' }} />
                                <span style={{ fontSize: '14px' }}>{lpToken.tokenSymbol}</span>
                                <span>/</span>
                                <img src={lpToken.backingTokenLogo} alt={lpToken.backingTokenSymbol} style={{ width: '25px', height: '25px', borderRadius: '50%' }} />
                                <span style={{ fontSize: '14px' }}>{lpToken.backingTokenSymbol}</span>
                            </div>
                            <div style={{ fontSize: '18px', fontWeight: 'bold' }}>
                                {/* <div style={{ fontSize: '18px', fontWeight: 'bold', display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}> */}
                                {privacyMode ?

                                    <span>*****</span>
                                    :
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                                        <div>
                                            {displayMainValue}{' '}
                                        </div>
                                        <div style={{ fontSize: '14px', color: 'grey', fontWeight: 'normal' }}>
                                            ({displaySecondaryValue})
                                        </div>
                                    </div>}
                            </div>
                        </div>
                        {!advancedView && <div style={{
                            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                            overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                            marginTop: '5px',
                            backgroundColor: 'rgba(6, 0, 30, 0.9)',
                            fontSize: '11px', paddingLeft: '8px', paddingRight: '8px', paddingTop: '5px', paddingBottom: '5px', color: 'white', backgroundColor: 'rgba(0, 0, 0, 0.90)', borderRadius: '10px'
                        }}>
                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                <strong>{lpToken.dexName || 'Unknown'}</strong>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: '2px' }}>
                                <span>24h Vol:</span>
                                <span style={{ whiteSpace: 'pre' }}>{' '}</span>
                                <strong>{formatCurrencyExtended(lpToken.dailyVolumeUSD)}</strong>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: '2px' }}>
                                <span>APY:</span>
                                <span style={{ whiteSpace: 'pre' }}>{' '}</span>
                                <strong>{formatPercentage(lpToken.annualAPY)}</strong>
                            </div>
                        </div>}
                    </div>
                </NextCard.Body>

                {/* Darker section for details, similar to My Wallet tokens */}
                               {radarView && (
                                    <div>
                                      <RewardsPending
                                        token={tokenSelections.find(t => t.value.toLowerCase() === lpToken.token.toLowerCase())}
                                        account={lpToken.pairAddress}
                                        contracts={contracts}
                                        imageReferences={imageReferences}
                                        tokenSelections={tokenSelections}
                                        enableClaiming={false}
                                      />
                                      <RewardsPending
                                        token={tokenSelections.find(t => t.value.toLowerCase() === lpToken.backingToken.toLowerCase())}
                                        account={lpToken.pairAddress}
                                        contracts={contracts}
                                        imageReferences={imageReferences}
                                        tokenSelections={tokenSelections}
                                        enableClaiming={false}
                                      />
                                    </div>
                                  )}

            </NextCard>
            
            {advancedView &&
                <div
                    style={{
                        marginTop: '-20px',
                        backgroundColor: 'rgba(6, 0, 30, 0.9)',
                        borderRadius: '10px',
                        padding: '7px',
                        paddingTop: '30px',
                        color: 'white',
                        fontSize: '10px'
                    }}
                >
                    {/* Additional details */}
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(100px, 1fr))',
                        gap: '5px',
                        fontSize: '10px'
                    }}>

                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                            <span>Dex:</span>
                            <strong>{lpToken.dexName || 'Unknown'}</strong>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                            <span>Total LP Supply:</span>
                            {lpToken.totalSupply
                                ? <strong>{formatDecimals(lpToken.totalSupply, lpToken.decimals)} {lpToken.symbol}</strong>
                                : <LoadingSmallContent />}
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                            <span>Total LP Value:</span>
                            <strong>{formatCurrencyExtended(lpToken.tvlUSD)}</strong>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                            <span>LP Share:</span>
                            {lpToken.lpShare ? <strong>{formatPercentage(lpToken.lpShare / 100)}</strong> : <LoadingSmallContent />}
                        </div>

                        {/* dailyVolumeUSD */}
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                            <span>24h Volume:</span>
                            <strong>{formatCurrencyExtended(lpToken.dailyVolumeUSD)}</strong>
                        </div>
                        {/* annual APR */}
                        {/* <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
                            <span>APR:</span>
                            <strong>{formatPercentage(lpToken.annualAPR)}</strong>
                        </div> */}
                        {/* annual APY */}
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                            <span>APY:</span>
                            <strong>{formatPercentage(lpToken.annualAPY)}</strong>
                        </div>

                        

                    </div>

       

                    <div style={{
                        display: 'flex', flexDirection: 'column',
                        fontSize: '10px',
                        marginTop: '5px',
                        padding: '5px',
                        backgroundColor: 'rgba(94, 83, 83, 0.15)',
                        borderRadius: '10px',
                        outline: '1px solid grey',
                    }}>
                        <div>
                            {/* <div style={{ display: 'flex', flexDirection: 'row', gap: '5px', alignItems: 'center', fontWeight: 'bold' }}>
                                <img src={lpToken.tokenLogo} alt={lpToken.tokenSymbol} style={{ width: '25px', height: '25px', borderRadius: '50%' }} />
                                <span style={{ fontSize: '14px' }}>{lpToken.tokenSymbol}</span>
                            </div> */}
                            {/* Token side */}
                            <div style={{
                                display: 'grid',
                                gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
                                gap: '5px',
                                fontSize: '10px'
                            }}>
                                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                    <span>{lpToken.tokenSymbol} Bal:</span>
                                    {lpToken.tokenBalanceInLiquidityPair
                                        ? <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                          <img src={lpToken.tokenLogo} alt={lpToken.tokenSymbol} style={{ width: '15px', height: '15px', borderRadius: '50%' }} />
                                          <strong>{formatDecimals(lpToken.tokenBalanceInLiquidityPair, decimals)}</strong> {'(' + formatCurrencyExtended((lpToken.tokenBalanceInLiquidityPair / 10 ** decimals) * mainTokenPrice) + ')'} </span>
                                        : <LoadingSmallContent />}
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                    <span>Your {lpToken.tokenSymbol} Share:</span>
                                    {lpToken.tokenBalanceInLiquidityPair
                                        ? <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                          <img src={lpToken.tokenLogo} alt={lpToken.tokenSymbol} style={{ width: '15px', height: '15px', borderRadius: '50%' }} />
                                          <strong>{formatDecimals(lpToken.tokenBalanceInLiquidityPair * lpToken.lpShare / 100, decimals)}</strong> {'(' + formatCurrencyExtended((lpToken.tokenBalanceInLiquidityPair * lpToken.lpShare / 100 / 10 ** decimals) * mainTokenPrice) + ')'} </span>
                                        : <LoadingSmallContent />}
                                </div>
                            </div>
                        </div>

                        <div>
                            {/* <div style={{ display: 'flex', flexDirection: 'row', gap: '5px', alignItems: 'center', fontWeight: 'bold' }}>
                                <img src={lpToken.backingTokenLogo} alt={lpToken.backingTokenSymbol} style={{ width: '25px', height: '25px', borderRadius: '50%' }} />
                                <span style={{ fontSize: '14px' }}>{lpToken.backingTokenSymbol}</span>
                            </div> */}

                            {/* Backing token side */}
                            <div style={{
                                display: 'grid',
                                gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
                                gap: '5px',
                                fontSize: '10px'
                            }}>
                                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                    <span>{lpToken.backingTokenSymbol} Bal:</span>
                                    {lpToken.backingTokenBalanceInLiquidityPair
                                        ? <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                          <img src={lpToken.backingTokenLogo} alt={lpToken.backingTokenSymbol} style={{ width: '15px', height: '15px', borderRadius: '50%' }} />
                                          <strong>{formatDecimals(lpToken.backingTokenBalanceInLiquidityPair, lpToken.backingTokenDecimals)}</strong> {'(' + formatCurrencyExtended((lpToken.backingTokenBalanceInLiquidityPair / 10 ** lpToken.backingTokenDecimals) * backingTokenPrice) + ')'} </span>
                                        : <LoadingSmallContent />}
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                    <span>Your {lpToken.backingTokenSymbol} Share:</span>
                                    {lpToken.backingTokenBalanceInLiquidityPair
                                        ? <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                          <img src={lpToken.backingTokenLogo} alt={lpToken.backingTokenSymbol} style={{ width: '15px', height: '15px', borderRadius: '50%' }} />
                                          <strong>{formatDecimals(lpToken.backingTokenBalanceInLiquidityPair * lpToken.lpShare / 100, lpToken.backingTokenDecimals)}</strong> {'(' + formatCurrencyExtended((lpToken.backingTokenBalanceInLiquidityPair * lpToken.lpShare / 100 / 10 ** lpToken.backingTokenDecimals) * backingTokenPrice) + ')'} </span>
                                        : <LoadingSmallContent />}
                                </div>
                            </div>
                        </div>

                    </div>
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(100px, 1fr))',
                        gap: '5px',
                        fontSize: '10px'
                    }}>
                        {/* LP Token Address */}
                        <div style={{ display: 'flex', flexDirection: 'column', marginTop: '5px' }}>
                            <span>LP Token:</span>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                <strong>{formatWalletAddress(lpToken.pairAddress)}</strong>
                                <IconButton
                                    style={{ padding: 0 }}
                                    onClick={() => {
                                        navigator.clipboard.writeText(lpToken.pairAddress);
                                        toast.success(`Copied LP address: ${lpToken.pairAddress}`);
                                    }}
                                >
                                    <ContentCopyIcon style={{ fontSize: '14px', cursor: 'pointer', color: 'white' }} />
                                </IconButton>
                            </div>
                        </div>

                        {/* Primary Token Address */}
                        <div style={{ display: 'flex', flexDirection: 'column', marginTop: '5px' }}>
                            <span>{lpToken.tokenSymbol}:</span>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                <strong>{formatWalletAddress(lpToken.token)}</strong>
                                <IconButton
                                    style={{ padding: 0 }}
                                    onClick={() => {
                                        navigator.clipboard.writeText(lpToken.token);
                                        toast.success(`Copied token address: ${lpToken.token}`);
                                    }}
                                >
                                    <ContentCopyIcon style={{ fontSize: '14px', cursor: 'pointer', color: 'white' }} />
                                </IconButton>
                            </div>
                        </div>

                        {/* Backing Token Address */}
                        <div style={{ display: 'flex', flexDirection: 'column', marginTop: '5px' }}>
                            <span>{lpToken.backingTokenSymbol}:</span>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                <strong>{formatWalletAddress(lpToken.backingToken)}</strong>
                                <IconButton
                                    style={{ padding: 0 }}
                                    onClick={() => {
                                        navigator.clipboard.writeText(lpToken.backingToken);
                                        toast.success(`Copied backing token address: ${lpToken.backingToken}`);
                                    }}
                                >
                                    <ContentCopyIcon style={{ fontSize: '14px', cursor: 'pointer', color: 'white' }} />
                                </IconButton>
                            </div>
                        </div>

                    </div>
                    <LpPerformance account={account} lpToken={lpToken} getTokenLogoUrl={getTokenLogoUrl} />
                </div>}
        </div>
    );
});

const calculate24hVolume = async (pairAddress, web3Instance, abi) => {
    try {
        const currentBlock = await web3Instance.eth.getBlockNumber();
        const currentBlockData = await web3Instance.eth.getBlock(currentBlock);
        const currentTime = currentBlockData.timestamp;
        const targetTime = currentTime - 86400; // 24 hours in seconds

        // Binary search to find the block number closest to targetTime
        let start = 0;
        let end = currentBlock;
        let targetBlock = currentBlock;

        while (start <= end) {
            let mid = Math.floor((start + end) / 2);
            let block = await web3Instance.eth.getBlock(mid);
            if (block.timestamp < targetTime) {
                start = mid + 1;
            } else if (block.timestamp > targetTime) {
                end = mid - 1;
            } else {
                targetBlock = mid;
                break;
            }
        }

        // Fetch Swap events from targetBlock to currentBlock
        const pairContract = new web3Instance.eth.Contract(abi, pairAddress);
        const events = await pairContract.getPastEvents('Swap', {
            fromBlock: targetBlock,
            toBlock: 'latest'
        });

        // Sum up the amounts to calculate volume
        let totalVolume = new BigNumber(0);
        events.forEach(event => {
            // Assuming the event has amount0In, amount1In, amount0Out, amount1Out
            const amount0In = new BigNumber(event.returnValues.amount0In || 0);
            const amount1In = new BigNumber(event.returnValues.amount1In || 0);
            const amount0Out = new BigNumber(event.returnValues.amount0Out || 0);
            const amount1Out = new BigNumber(event.returnValues.amount1Out || 0);

            totalVolume = totalVolume.plus(amount0In).plus(amount1In).plus(amount0Out).plus(amount1Out);
        });

        return totalVolume.toNumber(); // Return as a number or keep as BigNumber based on your preference
    } catch (error) {
        console.error(`Error calculating 24h volume for pair ${pairAddress}:`, error);
        return 0;
    }
};


const Wallet = ({ tokenSelections, refreshData, imageReferences, bnbPrice, setPauseRefresh }) => {
    const { library, account } = useWeb3React();
    const contractContext = useContext(ContractContext);
    const contracts = contractContext.contracts;
    const [includeAllTokens, setIncludeAllTokens] = useState(false);
    const [bnbBalance, setBnbBalance] = useState(0);
    const [walletHoldings, setWalletHoldings] = useState([]);
    //const [lpHoldings, setLpHoldings] = useState([]); // State for LP Holdings
    const [lpHoldings, setLpHoldings] = useState(new Map());
    const [lpHoldingsPending, setLpHoldingsPending] = useState(new Map());
    const [loadingLpPairs, setLoadingLpPairs] = useState(new Set());

    const [showModal, setShowModal] = useState(false);
    const [filteredTokens, setFilteredTokens] = useState([]);
    const [radarView, setRadarView] = useState(() => {
        return false;
        //const radarView = localStorage.getItem('radarView');
        //return radarView ? JSON.parse(radarView) : false;
    });
    const [advancedView, setAdvancedView] = useState(() => {
        const advancedView = localStorage.getItem('advancedView');
        return advancedView ? JSON.parse(advancedView) : false;
    });
    const [privacyMode, setPrivacyMode] = useState(() => {
        const privacyMode = localStorage.getItem('privacyMode');
        return privacyMode ? JSON.parse(privacyMode) : false;
    });
    const [usdView, setUsdView] = useState(() => localStorage.getItem('usdView') === 'true');

    const [sortOrderExplore, setSortOrderExplore] = useState('desc'); // Default to descending order

    // Load search query from localStorage
    const [searchQueryExplore, setSearchQueryExplore] = useState(() => localStorage.getItem('searchQueryExplore') || '');
    const deferredSearchQuery = useDeferredValue(searchQueryExplore);

    // Load sort criteria from localStorage
    const [sortCriteriaExplore, setSortCriteriaExplore] = useState(() => localStorage.getItem('sortCriteriaExplore') || 'marketCap');

    const refreshRef = useRef(refreshData);
    useEffect(() => { refreshRef.current = refreshData; }, [refreshData]);

    // New State Variables
    const [isFetchingLp, setIsFetchingLp] = useState(false);
    const [isDeepScan, setIsDeepScan] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);

    // State to track selected tokens and their liquidity pairs
    const [selectedLiquidityPairs, setSelectedLiquidityPairs] = useState(new Map());

    // State to track fetching status for each selected token
    const [isFetchingLiquidityPairs, setIsFetchingLiquidityPairs] = useState(new Map());

    const [multiSyncing, setMultiSyncing] = useState(false);

    // Pagination and Search State for Explore

    const [currentPageExplore, setCurrentPageExplore] = useState(1);
    const itemsPerPageExplore = 12; // Adjust as needed

    // Initialize LP Holdings Cache
    const LpCache = useRef(new Map());

    const deepScanToastShownRef = useRef(false); // Ref to track if deep scan toast has been shown
    const initialScanToastShownRef = useRef(false); // Ref for initial scan toast

    const [showHolderModal, setShowHolderModal] = useState(false);
    const holderAddress = account;

    // Right after all your existing useState declarations:
    const [timeFrame, setTimeFrame] = useState('24h');

    // The dropdown's options:
    const TIMEFRAME_OPTIONS = [
        { label: '1h', value: '1h' },
        { label: '3h', value: '3h' },
        { label: '6h', value: '6h' },
        { label: '12h', value: '12h' },
        { label: '24h', value: '24h' },
        { label: '3d', value: '3d' },
        { label: '7d', value: '7d' },
    ];

    
    const shallowEqualToken = (a, b) =>
      a.balanceUSD       === b.balanceUSD &&
      a.balanceOfHolder  === b.balanceOfHolder &&
      a.price            === b.price &&
      a.volume24h        === b.volume24h &&
      a.liquidityBacking === b.liquidityBacking && 
      a.liquidityValue   === b.liquidityValue;

    const diffAndSetWalletHoldings = useCallback(
      (next) => setWalletHoldings(prev => {
        // ❶ bailout – nothing really changed
        if (prev.length === next.length &&
            prev.every((t, i) => shallowEqualToken(t, next[i]))) {
          return prev;                   // === old ref → zero re-renders
        }

        // ❷ merge – reuse objects that didn't change
        const prevMap = new Map(prev.map(t => [t.address, t]));
        const merged  = next.map(t => {
          const old = prevMap.get(t.address);
          return old && shallowEqualToken(old, t) ? old : t;
        });

        return merged;
      }),
      []
    );


    // Load cache from localStorage on mount or account change
    useEffect(() => {
        if (!account) return;

        const loadCacheForAccount = () => {
            const cacheString = localStorage.getItem('LpCache');
            if (cacheString) {
                try {
                    const parsedCache = JSON.parse(cacheString);
                    const accountKey = account.toLowerCase();
                    if (parsedCache[accountKey]) {
                        LpCache.current = new Map(Object.entries(parsedCache[accountKey]));
                    } else {
                        LpCache.current = new Map();
                    }
                } catch (error) {
                    console.error("Error parsing LpCache from localStorage:", error);
                    LpCache.current = new Map();
                }
            } else {
                LpCache.current = new Map();
            }
            const loadedPairs = Array.from(LpCache.current.values());
            setLpHoldings(new Map(loadedPairs.map(lp => [lp.pairAddress.toLowerCase(), lp])));
        };

        loadCacheForAccount();
    }, [account]);

    // Function to save cache back to localStorage
    const saveCacheToLocalStorage = useCallback(() => {
        const cacheString = localStorage.getItem('LpCache');
        let parsedCache = {};

        if (cacheString) {
            try {
                parsedCache = JSON.parse(cacheString);
            } catch (error) {
                console.error("Error parsing LpCache from localStorage:", error);
                parsedCache = {};
            }
        }

        const accountKey = account.toLowerCase();
        parsedCache[accountKey] = Object.fromEntries(LpCache.current);

        localStorage.setItem('LpCache', JSON.stringify(parsedCache));
    }, [account]);

    // Function to update cache
    const updateLpHoldingsCache = useCallback((pairAddress, lpData) => {
        LpCache.current.set(pairAddress.toLowerCase(), lpData);
        saveCacheToLocalStorage();
    }, [saveCacheToLocalStorage]);

    // Function to validate cached LP holdings
    const validateCachedLpHoldings = useCallback(async () => {
        if (!contracts || !contracts.liquidityOracle || !account) return;

        //const web3 = new Web3(library.provider);
        const web3 = new Web3(new HTTPProvider("https://bsc-rpc.publicnode.com"));
        const accountLower = account.toLowerCase();

        const validLpHoldings = [];

        // Iterate over cached LP pairs for the current account
        for (let [pairAddress, lpData] of LpCache.current.entries()) {
            try {
                const lpTokenContract = new web3.eth.Contract(ierc20Abi, pairAddress);
                const holderLPTokenBalance = await lpTokenContract.methods.balanceOf(account).call();
                const lpBalanceBN = new BigNumber(holderLPTokenBalance || 0);

                if (lpBalanceBN.gt(0)) {
                    // Update balance if necessary
                    lpData.lpTokenBalance = lpBalanceBN.toNumber();
                    //console.log(`Validated LP balance for pair ${pairAddress}:`, lpData);
                    validLpHoldings.push(lpData);
                } else {
                    // Remove from cache if balance is zero
                    LpCache.current.delete(pairAddress);
                }
            } catch (error) {
                console.error(`Error validating LP balance for pair ${pairAddress}:`, error);
                // Optionally, remove from cache if there's an error fetching
                LpCache.current.delete(pairAddress);
            }
        }

        // Save the updated cache to localStorage
        saveCacheToLocalStorage();

        // Update state with valid LP holdings
        setLpHoldings(new Map(validLpHoldings.map(lp => [lp.pairAddress.toLowerCase(), lp])));
    }, [contracts, account, library.provider, saveCacheToLocalStorage]);

    const addLpHoldings = useCallback((newLpTokens) => {
        setLpHoldings(prevLpHoldings => {
            const updatedLpHoldings = new Map(prevLpHoldings);
            newLpTokens.forEach(lpToken => {
                const pairAddress = lpToken.pairAddress.toLowerCase();
                if (!updatedLpHoldings.has(pairAddress)) {
                    updatedLpHoldings.set(pairAddress, lpToken);
                }
                // If you need to update existing tokens, handle it here
            });
            return updatedLpHoldings;
        });
    }, []);

    // Update the search query and save to localStorage
    const handleSearchQueryChange = (e) => {
        const query = e.target.value;
        setSearchQueryExplore(query);
        localStorage.setItem('searchQueryExplore', query); // Save to localStorage
        setCurrentPageExplore(1); // Reset to first page on search
    };

    const handleSortCriteriaChange = (e) => {
        const criteria = e.target.value;
        const newOrder = sortOrderExplore === 'asc' ? 'desc' : 'asc'; // Toggle the sort order

        setSortCriteriaExplore(criteria);
        setSortOrderExplore(newOrder);
        localStorage.setItem('sortCriteriaExplore', criteria); // Save to localStorage
        localStorage.setItem('sortOrderExplore', newOrder); // Save sort order to localStorage
    };



    const getTokenLogoUrl = useCallback((token) => getTokenLogo(imageReferences, token), [imageReferences]);
    const getPairTokenLogoUrl = useCallback((pair) => {
        // Assuming pair has token and backingToken properties
        return [
            getTokenLogo(imageReferences, { address: pair.token, symbol: pair.symbol }),
            getTokenLogo(imageReferences, { address: pair.backingToken, symbol: pair.backingTokenSymbol })
        ];
    }, [imageReferences]);

    // Fetch BNB Balance
    useEffect(() => {
        if (!library || !account) return;
        const web3 = new Web3(library.provider);

        const fetchBNBBalance = async () => {
            try {
                const balance = await web3.eth.getBalance(account);
                setBnbBalance(balance);
            } catch (error) {
                console.error("Error fetching BNB balance:", error);
            }
        };

        fetchBNBBalance();

    }, [library, account]);

    const handleApproxUsdValueChange = useCallback((lpToken, newUsdValue) => {
        setLpHoldings((prev) => {
            const clone = new Map(prev);

            const key = lpToken.pairAddress.toLowerCase();
            const existing = clone.get(key) || { ...lpToken };
            // Overwrite or set approxUsdValue
            existing.approxUsdValue = newUsdValue;

            clone.set(key, existing);
            return clone;
        });
    }, []);

    // Toggle to include all tokens or hide small balances
    const options = ['Hide Small Balances', 'View All'];
    const [value, setValue] = useState(options[1]);

    useEffect(() => {
        if (value === options[0]) {
            setIncludeAllTokens(false);
        } else {
            setIncludeAllTokens(true);
        }
    }, [value]);


    // Fetch liquidity pairs for a token
    const getLiquidityPairs = useCallback(async (token, isInitialLoad = false) => {
        try {
            if (isInitialLoad && token.address.toLowerCase() === "0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c") return [];

            const web3 = new Web3(new HTTPProvider("https://bsc-rpc.publicnode.com"));
            const liquidityOracleAddress = contracts.liquidityOracle._address;
            const liquidityOracleContract = new web3.eth.Contract(liquidityOracleAbi, liquidityOracleAddress);

            let liquidityOracleData;
            try {
                liquidityOracleData = await liquidityOracleContract.methods
                    .getLiquidityPairsInfo(token.address, true, false)
                    .call();
            } catch (error) {
                console.error("Error fetching liquidity pairs from llamarpc, falling back to default provider:", error);
                liquidityOracleData = await contracts.liquidityOracle.methods
                    .getLiquidityPairsInfo(token.address, true, false)
                    .call();
            }

            if (!liquidityOracleData) return [];

            const uniqueData = Array.from(new Set(liquidityOracleData.map(a => a?.[3]?.toLowerCase())))
                .map(pairAddressLower => {
                    return liquidityOracleData.find(a => a?.[3]?.toLowerCase() === pairAddressLower);
                })
                .filter(Boolean); // Remove undefined if any

            // Enrich the pairs with token symbols
            const enrichedPairs = uniqueData.map(pair => {
                const tokenData = tokenSelections.find(t => t.value.toLowerCase() === pair.token.toLowerCase());
                const backingTokenData = tokenSelections.find(t => t.value.toLowerCase() === pair.backingToken.toLowerCase());

                return {
                    ...pair,
                    tokenSymbol: tokenData ? tokenData.label : 'Unknown',
                    backingTokenSymbol: backingTokenData ? backingTokenData.label : 'Unknown',
                    // // Keep the normal fields:
                    // tokenBalanceInLiquidityPair: pair.tokenBalanceInLiquidityPair,
                    // backingTokenBalanceInLiquidityPair: pair.backingTokenBalanceInLiquidityPair,

                    // // Also keep "oracle" fields if you want them displayed separately
                    oracleTokenBalanceInLiquidityPair: pair.tokenBalanceInLiquidityPair,
                    oracleBackingTokenBalanceInLiquidityPair: pair.backingTokenBalanceInLiquidityPair,
                };
            });
            //console.log("Enriched Pairs:", enrichedPairs);
            return enrichedPairs;
        } catch (error) {
            console.error("Error fetching liquidity pairs:", error);
            return [];
        }
    }, [contracts.liquidityOracle, tokenSelections]);

    const calculateLiquidityBacking = useCallback((token) => {
        const selectedTokenAddress = token.address.toLowerCase();
        const tokenLiquidityPairs = token.liquidityPairs || [];

        const tokenBalanceSum = tokenLiquidityPairs.reduce((sum, pair) => {
            let tokenBalanceInLiquidityPair = new BigNumber(0);
            if (pair.backingToken.toLowerCase() === selectedTokenAddress) {
                tokenBalanceInLiquidityPair = new BigNumber(pair.backingTokenBalanceInLiquidityPair);
            } else {
                tokenBalanceInLiquidityPair = new BigNumber(pair.tokenBalanceInLiquidityPair);
            }
            return sum.plus(tokenBalanceInLiquidityPair);
        }, new BigNumber(0));

        const totalSupply = new BigNumber(token.totalSupply || 0);

        // Define special tokens that have a fixed liquidity backing
        const specialTokens = [
            "0x27874A586bafaF54d4Cd0aae368ad9569D06d115",
            "0x0Cab564F58AD72877F0bc3Cd52468860294c15a6",
            "0x904B4224acA463666E98f21cC8C54f8D423f6648",
            "0xDfD077c9C2F488e5CFeD14EbBcb7B8E056334EbA",
            "0x3834303483f139c26bc282528aDee6b7Da103D54",
            "0x09b22c55436cb5F4F91306e632e0a5F0DD031BA8",
            "0x2a5D78825Bf470e70f9B62F2BCE8483941c11132",
        ];

        const isSpecialToken = specialTokens.includes(selectedTokenAddress);

        // Calculate liquidity backing percentage
        const liquidityBacking = isSpecialToken
            ? new BigNumber(1)
            : tokenBalanceSum.div(totalSupply).times(2); // Multiply by 2 as per your example

        return liquidityBacking;
    }, []);

    const calculateLiquidityValue = useCallback((token) => {
        const totalSupply = new BigNumber(token.totalSupply || 0);
        const marketCap = totalSupply.dividedBy(new BigNumber(10).pow(token.decimals)).times(token.price);
        const liquidityBacking = new BigNumber(token.liquidityBacking || 0); // Ensure it's a BigNumber

        const liquidityValue = marketCap.times(liquidityBacking);

        return liquidityValue;
    }, []);



    // Consolidated useEffect to map tokenSelections and fetch liquidity pairs
    useEffect(() => {
        const fetchAndSetWalletHoldings = async () => {
            if (!tokenSelections || tokenSelections?.length === 0) {
                setWalletHoldings([]);
                return;
            }

            try {
                // Map tokenSelections to walletHoldings with balanceUSD
                const mappedTokens = tokenSelections
                    .map(token => ({
                        address: token.value,
                        name: token.name, // Include the name property
                        symbol: token.label,
                        label: token.label,
                        totalSupply: token.totalSupply,
                        decimals: token.decimals,
                        price: token.price,
                        balanceOfHolder: token.label === "WBNB" ? bnbBalance : token.balanceOfHolder,
                        balanceUSD: token.label === "WBNB" ?
                            calculateBNBBalanceUSD(token, bnbBalance)
                            : calculateTokenBalanceUSD(token)
                    }))
                    .sort((a, b) => b.balanceUSD - a.balanceUSD)
                    .filter((token) => token.balanceUSD > (includeAllTokens ? 0.009 : 1));

                //console.log("Mapped Tokens:", mappedTokens);

                // Fetch liquidity pairs for all tokens concurrently with limited concurrency
                const enrichedTokens = await Promise.all(
                  mappedTokens.map((token) => tokenLimiter(async () => {
                    const liquidityPairs = await getLiquidityPairs(token, true);
                    const liquidityData = {
                        ...token,
                        liquidityPairs,
                    };

                    // Calculate liquidity backing
                    const liquidityBacking = calculateLiquidityBacking(liquidityData).toNumber(); // Convert to number for percentage

                    // Calculate liquidity value
                    const liquidityValue = calculateLiquidityValue({
                        ...liquidityData,
                        liquidityBacking
                    }).toNumber(); // Convert to number for USD value

                    // Fetch and aggregate Dexscreener data
                    const dexscreenerData = await getDexscreenerData(token.address);

                    const chartingData = await getChartingDataQuick(token.address, timeFrame);
                    //console.log("Charting Data for token:", token.address, chartingData);

                    return {
                        ...liquidityData,
                        liquidityBacking, // Percentage
                        liquidityValue,   // USD value
                        chartingData,
                        ...dexscreenerData // volume24h, totalBuys24h, totalSells24h, averagePriceChange24h
                    };
                })));

                 diffAndSetWalletHoldings(enrichedTokens);
            } catch (error) {
                console.error("Error fetching wallet holdings:", error);
            }
        };

        fetchAndSetWalletHoldings();
    }, [tokenSelections, includeAllTokens, bnbBalance, calculateBNBBalanceUSD, calculateTokenBalanceUSD, getLiquidityPairs, timeFrame]);

    // Reset toast flags on account change
    useEffect(() => {
        initialScanToastShownRef.current = false;
        deepScanToastShownRef.current = false;
    }, [account]);


    // Handle token selection modal
    const handleTokenClick = useCallback(() => {
        setShowModal(true);
        setFilteredTokens(tokenSelections);
    }, [tokenSelections]);

    const handleTokenSelect = useCallback((token) => {
        // Implement any actions upon selecting a token if needed
        setShowModal(false);
    }, []);

    const handleCloseModal = useCallback(() => {
        setShowModal(false);
    }, []);

    const [openModals, setOpenModals] = useState({});
    const [lpModalsOpen, setLpModalsOpen] = useState({});

    useEffect(() => {
        setPauseRefresh(Object.keys(openModals).length > 0);
    }, [openModals]);

    useEffect(() => {
        setPauseRefresh(Object.keys(lpModalsOpen).length > 0);
    }, [lpModalsOpen]);

    const [exploreDataCache, setExploreDataCache] = useState(new Map());


    const fetchTokenDetails = async (token) => {
        const tokenAddress = token.address.toLowerCase();

        // Check cache first to avoid redundant API calls
        if (exploreDataCache.has(tokenAddress)) {
            return { ...token, ...exploreDataCache.get(tokenAddress) };
        }

        try {
            const liquidityPairs = await getLiquidityPairs(token);

            // Calculate liquidity backing and value
            const liquidityBacking = calculateLiquidityBacking({ ...token, liquidityPairs }).toNumber();
            const liquidityValue = calculateLiquidityValue({ ...token, liquidityBacking }).toNumber();

            // Fetch dexscreener data
            const dexscreenerData = await getDexscreenerData(token.address);

            const fetchedData = { liquidityBacking, liquidityValue, ...dexscreenerData, liquidityPairs };
            setExploreDataCache((prevCache) => new Map(prevCache).set(tokenAddress, fetchedData));

            return { ...token, ...fetchedData };
        } catch (error) {
            console.error("Error fetching token details:", error);
            throw error;
        }
    };


    const handleTokenCardClick = useCallback(async (token) => {
        const tokenAddress = token.address.toLowerCase();
        let selectedToken = walletHoldings.find(t => t.address.toLowerCase() === tokenAddress)
            || tokenSelections.find(t => t.value.toLowerCase() === tokenAddress);

        // If liquidity data is not already available, fetch it
        if (!selectedToken.liquidityPairs || selectedToken.liquidityPairs.length === 0) {
            try {
                // Fetch token details including liquidity pairs
                const enrichedToken = await fetchTokenDetails(token);
                //console.log("Enriched Token:", enrichedToken);
                selectedToken = enrichedToken;

                // Update walletHoldings state:
                // - If the token exists, replace it
                // - If not, add it
                setWalletHoldings(prevHoldings => {
                    const index = prevHoldings.findIndex(t => t.address.toLowerCase() === enrichedToken.address.toLowerCase());
                    if (index !== -1 && shallowEqualToken(prevHoldings[index], enrichedToken)) {
                        // Replace existing token
                        return prevHoldings
                    } 
                    const next = [...prevHoldings];
                    index === -1 ? next.push(enrichedToken) : (next[index] = enrichedToken);
                    return next;
                });
            } catch (error) {
                console.error("Error fetching token details:", error);
                return; // Exit early if fetching fails
            }
        }

        // Open the modal for the selected token
        setOpenModals((prev) => ({
            ...prev,
            [tokenAddress]: true,
        }));
    }, [walletHoldings, tokenSelections, fetchTokenDetails]);



    const handleCloseTokenModal = useCallback((address) => {
        setOpenModals((prev) => {
            const newModals = { ...prev };
            delete newModals[address.toLowerCase()];
            return newModals;
        });
    }, []);

    const createCloseHandler = useCallback((address) => () => {
        handleCloseTokenModal(address);
    }, [handleCloseTokenModal]);


    const handleRadarView = useCallback(() => {
        setRadarView(prev => {
            const newRadarView = !prev;
            localStorage.setItem('radarView', newRadarView);
            return newRadarView;
        });
    }, []);

    const handleAdvancedView = useCallback(() => {
        setAdvancedView(prev => {
            const newAdvancedView = !prev;
            localStorage.setItem('advancedView', newAdvancedView);
            return newAdvancedView;
        });
    }, []);

    const handlePrivacyMode = useCallback(() => {
        setPrivacyMode(prev => {
            const newPrivacyMode = !prev;
            localStorage.setItem('privacyMode', newPrivacyMode);
            return newPrivacyMode;
        });
    }, []);

    const lpHoldingsRef = useRef(lpHoldings);

    // Persist usdView to localStorage
    useEffect(() => {
        usdView ? localStorage.setItem('usdView', 'true') : localStorage.setItem('usdView', 'false');
    }, [usdView]);

    const enrichLpTokenWithSymbols = useCallback((lpToken, tokenSelections) => {
        const tokenData = tokenSelections?.find(t => t.value.toLowerCase() === lpToken.token.toLowerCase());
        const backingTokenData = tokenSelections?.find(t => t.value.toLowerCase() === lpToken.backingToken.toLowerCase());

        return {
            ...lpToken,
            tokenSymbol: tokenData ? tokenData.label : "Unknown",
            backingTokenSymbol: backingTokenData ? backingTokenData.label : "Unknown",
            tokenBalanceInLiquidityPair: lpToken.tokenBalanceInLiquidityPair,
            backingTokenBalanceInLiquidityPair: lpToken.backingTokenBalanceInLiquidityPair,

            // Also keep "oracle" fields if you want them displayed separately
            oracleTokenBalanceInLiquidityPair: lpToken.oracleTokenBalanceInLiquidityPair,
            oracleBackingTokenBalanceInLiquidityPair: lpToken.oracleBackingTokenBalanceInLiquidityPair,
        };
    }, [tokenSelections]);


    // At the top of your Wallet component, add a ref flag:
    const hasDeepScannedRef = useRef(false);

    // Modify performDeepScan to capture walletHoldings once and only run once:

    const performDeepScan = useCallback(async () => {
        if (isDeepScan) return; // Prevent multiple scans

        setIsDeepScan(true);

        try {
            const deepScanLpTokens = [];
            //const web3 = new Web3(library.provider); // Initialize Web3
            const web3 = new Web3(new HTTPProvider("https://bsc-rpc.publicnode.com"));
            const CONCURRENT_LIMIT = 5;
            const limit = pLimit(CONCURRENT_LIMIT);

            // Step 3: Deep Scan (Against Remaining Token Selections)
            const remainingTokens = tokenSelections.filter(token =>
                !walletHoldings.some(walletToken => walletToken.address.toLowerCase() === token.value.toLowerCase())
            );

            if (remainingTokens.length === 0) {
                toast.info("No additional tokens to deep scan.");
                setIsDeepScan(false);
                return;
            }

            const deepScanToastId = 'deep-scan';

            const batchSize = 10;
            for (let i = 0; i < remainingTokens.length; i += batchSize) {
                const batch = remainingTokens.slice(i, i + batchSize);
                await Promise.all(batch.map(token => limit(async () => {
                    const liquidityPairs = await getLiquidityPairs(token);
                    await Promise.all(liquidityPairs.map(async (pair) => {
                        try {
                            const pairAddress = pair.pairAddress.toLowerCase();

                            // if (LpCache.current.has(pairAddress)) {
                            //     deepScanLpTokens.push(LpCache.current.get(pairAddress));
                            //     return;
                            // }

                            const lpTokenContract = new web3.eth.Contract(ierc20Abi, pairAddress);
                            const tokenContract = new web3.eth.Contract(ierc20Abi, pair.token);
                            // console.log("pair.pairAddress", pair.pairAddress);
                            // console.log("pair.token", pair.token);
                            const holderLPTokenBalance = await lpTokenContract.methods.balanceOf(account).call();
                            const lpBalanceBN = new BigNumber(holderLPTokenBalance || 0);

                            if (lpBalanceBN.gt(0)) {
                                const totalSupply = await lpTokenContract.methods.totalSupply().call();
                                const lpShare = calculateLPShare(holderLPTokenBalance, totalSupply).times(100).toFixed(2);

                                const [tokenLogo, backingTokenLogo] = getPairTokenLogoUrl(pair);
                                const decimals = await lpTokenContract.methods.decimals().call();
                                const name = await lpTokenContract.methods.name().call();
                                const symbol = await lpTokenContract.methods.symbol().call();
                                const tokenDecimals = await tokenContract.methods.decimals().call();

                                const lpData = {
                                    ...pair,
                                    lpTokenBalance: lpBalanceBN.toNumber(),
                                    tokenLogo,
                                    backingTokenLogo,
                                    decimals: parseInt(decimals),
                                    price: pair.price || 0,
                                    totalSupply,
                                    name,
                                    symbol,
                                    tokenName: token.name,
                                    lpShare,
                                    tokenDecimals: parseInt(tokenDecimals),
                                };

                                if (!lpHoldings.has(pairAddress)) {
                                    // This is a new pair we haven't seen
                                    setLoadingLpPairs(prev => new Set([...prev, pairAddress]));
                                }

                                const stats = await fetchLpStats(lpData, web3, tokenSelections);

                                // remove from loading set
                                setLoadingLpPairs(prev => {
                                    const newSet = new Set(prev);
                                    newSet.delete(pairAddress);
                                    return newSet;
                                });

                                // merge into main state
                                setLpHoldings((prev) => {
                                    const newMap = new Map(prev);
                                    newMap.set(pairAddress, stats);
                                    return newMap;
                                });

                                // Then push or store stats instead of lpData
                                deepScanLpTokens.push(stats);  // or lpTokens.push(stats)
                                updateLpHoldingsCache(pairAddress, stats);
                            }
                        } catch (error) {
                            console.error(`Error fetching LP balance for pair ${pair.pairAddress}:`, error);
                        }
                    }));
                })));

                await new Promise(resolve => setTimeout(resolve, 500)); // Throttle requests
            }

            const enrichedLpTokensDeep = deepScanLpTokens.map(lpToken => enrichLpTokenWithSymbols(lpToken, tokenSelections));

            // Filter duplicates before updating state
            addLpHoldings(enrichedLpTokensDeep);
            // setLpHoldings(enrichedLpTokensDeep);


            toast.update(deepScanToastId, {
                render: "Deep LP scan completed.",
                type: "success",
                autoClose: 2500,
                isLoading: false,
            });

            // Update last deep scan time
            const currentTime = new Date().getTime();
            localStorage.setItem('lastDeepScanTime', currentTime);

        } catch (error) {
            console.error("Error during deep scan:", error);
            toast.error("Deep LP scan failed.");
        } finally {
            setIsDeepScan(false);
        }
    }, [isDeepScan, tokenSelections, walletHoldings, getLiquidityPairs, enrichLpTokenWithSymbols, library.provider, account, updateLpHoldingsCache]);

    useEffect(() => {
        const fetchLpHoldings = async () => {
            // if (!walletHoldings || walletHoldings.length === 0) {
            //     //setLpHoldings(new Map()); // No wallet holdings, nothing to fetch
            //     return;
            // }

            try {
                setIsFetchingLp(true);
                const lpTokens = [];
                //const web3 = new Web3(library.provider); // Initialize Web3
                const web3 = new Web3(new HTTPProvider("https://bsc-rpc.publicnode.com"));
                const CONCURRENT_LIMIT = 1;
                const limit = pLimit(CONCURRENT_LIMIT);

                // Step 1: Validate existing cache
                await validateCachedLpHoldings();

                // Step 2: Basic LP Scan (Against Wallet Holdings)
                await Promise.all(walletHoldings.map(token => limit(async () => {

                    //only fetch bnb when opening it's tokeninfomodal window
                    if (token.address.toLowerCase() === "0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c") return;

                    const liquidityPairs = token.liquidityPairs || [];
                    await Promise.all(liquidityPairs.map(async (pair) => {
                        try {
                            const pairAddress = pair.pairAddress.toLowerCase();

                            // Check cache first (already validated)
                            // if (LpCache.current.has(pairAddress)) {
                            //     lpTokens.push(LpCache.current.get(pairAddress));
                            //     return;
                            // }

                            const lpTokenContract = new web3.eth.Contract(ierc20Abi, pairAddress);
                            const tokenContract = new web3.eth.Contract(ierc20Abi, pair.token);
                            // console.log("pair.pairAddress", pair.pairAddress);
                            // console.log("pair.token", pair.token);
                            const holderLPTokenBalance = await lpTokenContract.methods.balanceOf(account).call();
                            const lpBalanceBN = new BigNumber(holderLPTokenBalance || 0);

                            if (lpBalanceBN.gt(0)) {
                                const totalSupply = await lpTokenContract.methods.totalSupply().call();
                                const lpShare = calculateLPShare(holderLPTokenBalance, totalSupply).times(100).toFixed(2);

                                const [tokenLogo, backingTokenLogo] = getPairTokenLogoUrl(pair);
                                const decimals = await lpTokenContract.methods.decimals().call();
                                const name = await lpTokenContract.methods.name().call();
                                const symbol = await lpTokenContract.methods.symbol().call();
                                const tokenDecimals = await tokenContract.methods.decimals().call();

                                const lpData = {
                                    ...pair,
                                    lpTokenBalance: lpBalanceBN.toNumber(),
                                    tokenLogo,
                                    backingTokenLogo,
                                    decimals: parseInt(decimals),
                                    price: pair.price || 0,
                                    totalSupply,
                                    name,
                                    symbol,
                                    tokenName: token.name,
                                    lpShare,
                                    tokenDecimals: parseInt(tokenDecimals),
                                };
                                //console.log("lpData", lpData);
                                const stats = await fetchLpStats(lpData, web3, tokenSelections);
                                //console.log("stats =>", stats);  
                                // Then push or store stats instead of lpData
                                lpTokens.push(stats)
                                updateLpHoldingsCache(pairAddress, stats);
                            }
                        } catch (error) {
                            console.error(`Error fetching LP balance for pair ${pair.pairAddress}:`, error);
                        }
                    }));
                })));

                const enrichedLpTokens = lpTokens.map(lpToken => enrichLpTokenWithSymbols(lpToken, tokenSelections));

                addLpHoldings(enrichedLpTokens);

                if (!initialScanToastShownRef.current) {
                    // toast.success("Initial LP Scan Complete.", {
                    //     autoClose: 2000,
                    //     toastId: 'initial-scan', // Unique ID to prevent duplicates
                    // });
                    initialScanToastShownRef.current = true;
                }
                setIsFetchingLp(false);

                // Check if deep scan is needed (once every hour)
                const lastDeepScanTime = localStorage.getItem('lastDeepScanTime');
                const currentTime = new Date().getTime();
                const oncePerMonth = 30 * 24 * 60 * 60 * 1000;

                if (!lastDeepScanTime || (currentTime - lastDeepScanTime) > oncePerMonth) {
                    performDeepScan();
                }

            } catch (error) {
                console.error("Error fetching LP holdings:", error);
                setIsFetchingLp(false);
            }
        };
        if (!walletHoldings || walletHoldings.length === 0) {
            return;
        }
        fetchLpHoldings();
    }, [
        walletHoldings,
        tokenSelections,
        getPairTokenLogoUrl,
        library.provider,
        account,
        getLiquidityPairs,
        validateCachedLpHoldings,
        updateLpHoldingsCache,
        performDeepScan
    ]);



    // Handle LP Token Selection Modal (if needed)
    const handleLpTokenCardClick = useCallback((lpToken) => {
        setOpenModals((prev) => {
            if (prev[lpToken.pairAddress.toLowerCase()]) {
                // Modal is already open, do nothing
                return prev;
            } else {
                return { ...prev, [lpToken.pairAddress.toLowerCase()]: true };
            }
        });
    }, []);


    // Handle Radar View Switch
    const handleRadarViewSwitch = useCallback(() => {
        handleRadarView();
    }, [handleRadarView]);


    // Handle Advanced View Switch
    const handleAdvancedViewSwitch = useCallback(() => {
        handleAdvancedView();
    }, [handleAdvancedView]);

    // Grouping state and handler
    const [groupBy, setGroupBy] = useState('none'); // Default grouping by 'token'

    // Grouping options handler
    const handleGroupByChange = (e) => {
        setGroupBy(e.target.value);
    };

    // 1. Filter all LP tokens for approxUsdValue >= 0.009
    // 2. Sort them descending by approxUsdValue

    const filteredAndSortedLpHoldings = useMemo(() => {
        return Array.from(lpHoldings.values())
            //.filter(lp => (lp.approxUsdValue || 0) >= 0.009)
            .sort((a, b) => (b.approxUsdValue || 0) - (a.approxUsdValue || 0));
    }, [lpHoldings]);



    // Grouping logic to handle token bidirectional pairs
    const groupLpTokens = useCallback(() => {
        const seenPairs = new Set(); // Track seen pairs to avoid duplicates

        if (groupBy === 'none') {
            // No grouping, just return unique pairs
            const uniqueLpTokens = filteredAndSortedLpHoldings.filter((lpToken) => {
                const pairKey = `${lpToken.tokenSymbol}/${lpToken.backingTokenSymbol}`;
                const reversePairKey = `${lpToken.backingTokenSymbol}/${lpToken.tokenSymbol}`;

                if (!seenPairs.has(pairKey) && !seenPairs.has(reversePairKey)) {
                    seenPairs.add(pairKey);
                    return true; // Include this LP token
                }
                return false; // Skip duplicate
            });

            return { None: uniqueLpTokens }; // Return only unique LP tokens
        } else if (groupBy === 'dex') {
            // Group by Dex
            return filteredAndSortedLpHoldings.reduce((groups, lpToken) => {
                const pairKey = `${lpToken.tokenSymbol}/${lpToken.backingTokenSymbol}`;
                const reversePairKey = `${lpToken.backingTokenSymbol}/${lpToken.tokenSymbol}`;

                if (!seenPairs.has(pairKey) && !seenPairs.has(reversePairKey)) {
                    seenPairs.add(pairKey); // Mark this pair as seen

                    const groupKey = lpToken.dexName || 'Unknown Dex';
                    if (!groups[groupKey]) groups[groupKey] = [];
                    groups[groupKey].push(lpToken);
                }

                return groups;
            }, {});
        } else if (groupBy === 'token') {
            // Group by Token, ensuring bidirectional grouping
            return filteredAndSortedLpHoldings.reduce((groups, lpToken) => {
                const pairKey = `${lpToken.tokenSymbol}/${lpToken.backingTokenSymbol}`;
                const reversePairKey = `${lpToken.backingTokenSymbol}/${lpToken.tokenSymbol}`;

                if (!seenPairs.has(pairKey) && !seenPairs.has(reversePairKey)) {
                    seenPairs.add(pairKey); // Mark this pair as seen

                    // Add the LP token to the group of its own token
                    if (!groups[lpToken.tokenSymbol]) groups[lpToken.tokenSymbol] = [];
                    groups[lpToken.tokenSymbol].push(lpToken);

                    // Add the LP token to the group of its backing token (reverse the pair)
                    if (!groups[lpToken.backingTokenSymbol]) groups[lpToken.backingTokenSymbol] = [];
                    groups[lpToken.backingTokenSymbol].push({
                        ...lpToken,
                        // Reverse the display for the card
                        tokenSymbol: lpToken.backingTokenSymbol,
                        backingTokenSymbol: lpToken.tokenSymbol,
                        tokenLogo: lpToken.backingTokenLogo,
                        backingTokenLogo: lpToken.tokenLogo,
                    });
                }

                return groups;
            }, {});
        }
    }, [filteredAndSortedLpHoldings, groupBy]);



    // Get the grouped tokens
    //const groupedLpTokens = groupLpTokens();

    const [groupedLpTokens, setGroupedLpTokens] = useState({});

    useEffect(() => {
        setGroupedLpTokens(groupLpTokens());
    }, [lpHoldings, groupBy, groupLpTokens]);

    const memoizedHandleLpTokenCardClick = useCallback((lpToken) => {
        handleLpTokenCardClick(lpToken);
    }, [handleLpTokenCardClick]);



    useEffect(() => {
        // Iterate over token selections to fetch details if not cached
        tokenSelections.forEach(token => {
            const tokenAddress = token.value.toLowerCase();
            if (!exploreDataCache.has(tokenAddress)) {
                // Fetch token details if not cached
                fetchTokenDetails(token)
                    .then(enrichedToken => {
                        setExploreDataCache(prevCache => new Map(prevCache).set(tokenAddress, {
                            liquidityBacking: enrichedToken.liquidityBacking,
                            liquidityValue: enrichedToken.liquidityValue,
                            volume24h: enrichedToken.volume24h,
                            totalBuys24h: enrichedToken.totalBuys24h,
                            totalSells24h: enrichedToken.totalSells24h,
                            averagePriceChange24h: enrichedToken.averagePriceChange24h,
                            liquidityPairs: enrichedToken.liquidityPairs,
                        }));
                    })
                    .catch(error => console.error("Error fetching token details:", error));
            }
        });
    }, [tokenSelections, exploreDataCache]);

    const totalLpValueUSD = useMemo(() => {
        return Array.from(lpHoldings.values())
            .filter(lp => lp.pairAddress) // Ensure pairAddress exists
            .filter((lp, index, self) =>
                index === self.findIndex((t) => (
                    t.pairAddress.toLowerCase() === lp.pairAddress.toLowerCase()
                ))
            )
            .reduce((sum, lp) => sum + (lp.approxUsdValue || 0), 0);
    }, [lpHoldings]);


    const totalWalletUSD = calculateTotalWalletBalanceUSD(walletHoldings, bnbBalance, includeAllTokens);

    const grandTotalUSD = totalWalletUSD + totalLpValueUSD;

    // State for pagination
    const [selectedLiquidityPage, setSelectedLiquidityPage] = useState({});

    // Handler for changing page
    const handleSelectedLiquidityPageChange = (tokenAddress, newPage) => {
        setSelectedLiquidityPage(prev => ({
            ...prev,
            [tokenAddress]: newPage,
        }));
    };

    const itemsPerPageSelected = 6;

    const handleViewLiquidityPairs = useCallback(async (token) => {
        const tokenAddress = token.address.toLowerCase();

        // **Step 1: Toggle Selection**
        if (selectedLiquidityPairs.has(tokenAddress)) {
            // If already selected, remove it from the selected pairs
            setSelectedLiquidityPairs(prev => {
                const newMap = new Map(prev);
                newMap.delete(tokenAddress);
                return newMap;
            });
            // Also remove the associated page number
            setSelectedLiquidityPage(prev => {
                const newPages = { ...prev };
                delete newPages[tokenAddress];
                return newPages;
            });
            return;
        }

        // **Step 2: Check if Already Fetching**
        if (isFetchingLiquidityPairs.get(tokenAddress)) {
            // Prevent multiple fetches for the same token
            return;
        }

        // **Step 3: Check Cache**
        if (exploreDataCache.has(`${tokenAddress}_liquidityPairs`)) {
            const cachedPairs = exploreDataCache.get(`${tokenAddress}_liquidityPairs`);
            setSelectedLiquidityPairs(prev => new Map(prev).set(tokenAddress, cachedPairs));

            // Initialize the page number to 1
            setSelectedLiquidityPage(prev => ({
                ...prev,
                [tokenAddress]: 1,
            }));
            return;
        }

        // **Step 4: Set Fetching Status**
        setIsFetchingLiquidityPairs(prev => new Map(prev).set(tokenAddress, true));

        try {
            // **Step 5: Fetch Liquidity Pairs**
            const liquidityPairs = await getLiquidityPairs(token);

            // **Step 6: Initialize Web3**
            const web3 = new Web3(new HTTPProvider("https://bsc-rpc.publicnode.com"));

            // **Step 7: Process Each Pair**
            const enrichedLiquidityPairs = await Promise.all(liquidityPairs.map(async (pair) => {
                const pairAddress = pair.pairAddress.toLowerCase();

                // **Step 7.1: Check LpCache**
                if (LpCache.current.has(pairAddress)) {
                    // Retrieve from cache
                    return LpCache.current.get(pairAddress);
                }

                try {
                    // **Step 7.2: Initialize Contracts**
                    const lpTokenContract = new web3.eth.Contract(ierc20Abi, pairAddress);
                    const tokenContract = new web3.eth.Contract(ierc20Abi, pair.token);

                    // **Step 7.3: Fetch LP Token Balance**
                    const holderLPTokenBalance = await lpTokenContract.methods.balanceOf(account).call();
                    const lpBalanceBN = new BigNumber(holderLPTokenBalance || 0);


                    // **Step 7.4: Fetch Total Supply and Calculate LP Share**
                    const totalSupply = await lpTokenContract.methods.totalSupply().call();
                    const lpShare = calculateLPShare(holderLPTokenBalance, totalSupply).times(100).toFixed(2);

                    // **Step 7.5: Fetch Additional Token Details**
                    const [tokenLogo, backingTokenLogo] = getPairTokenLogoUrl(pair);
                    const decimals = await lpTokenContract.methods.decimals().call();
                    const name = await lpTokenContract.methods.name().call();
                    const symbol = await lpTokenContract.methods.symbol().call();
                    const tokenDecimals = await tokenContract.methods.decimals().call();

                    // **Step 7.6: Construct lpData Object**
                    const lpData = {
                        ...pair,
                        lpTokenBalance: lpBalanceBN.toNumber(),
                        tokenLogo,
                        backingTokenLogo,
                        decimals: parseInt(decimals),
                        price: pair.price || 0,
                        totalSupply,
                        name,
                        symbol,
                        tokenName: token.name,
                        lpShare,
                        tokenDecimals: parseInt(tokenDecimals),
                    };

                    // **Step 7.7: Fetch Additional LP Stats**
                    const stats = await fetchLpStats(lpData, web3, tokenSelections);

                    // **Step 7.8: Cache the Stats**
                    LpCache.current.set(pairAddress, stats);
                    updateLpHoldingsCache(pairAddress, stats);

                    return stats; // Return the enriched stats

                } catch (error) {
                    console.error(`Error processing pair ${pair.pairAddress}:`, error);
                    return null; // Skip this pair on error
                }
            }));

            // **Step 8: Filter Out Null Entries**
            const validEnrichedPairs = enrichedLiquidityPairs.filter(pair => pair !== null);

            // **Step 9: Enrich Remaining Pairs (if any)**
            const finalEnrichedPairs = await Promise.all(validEnrichedPairs.map(async (pair) => {
                // Enrich with symbols and other basic info if not already done
                let enrichedPair = enrichLpTokenWithSymbols(pair, tokenSelections);

                // Assign token logos (redundant if already assigned above, but safe to reassign)
                enrichedPair.tokenLogo = getTokenLogoUrl({ address: pair.token, symbol: pair.tokenSymbol });
                enrichedPair.backingTokenLogo = getTokenLogoUrl({ address: pair.backingToken, symbol: pair.backingTokenSymbol });

                return enrichedPair;
            }));

            // **Step 10: Update State with Enriched Liquidity Pairs**
            setSelectedLiquidityPairs(prev => new Map(prev).set(tokenAddress, finalEnrichedPairs));

            // **Step 11: Initialize Page Number**
            setSelectedLiquidityPage(prev => ({
                ...prev,
                [tokenAddress]: 1,
            }));

            // **Step 12: Cache the Fetched Liquidity Pairs**
            setExploreDataCache(prevCache => new Map(prevCache).set(`${tokenAddress}_liquidityPairs`, finalEnrichedPairs));

        } catch (error) {
            console.error(`Error fetching liquidity pairs for token ${token.symbol}:`, error);
            // Optionally, you can display a notification or toast to inform the user
        } finally {
            // **Step 13: Reset Fetching Status**
            setIsFetchingLiquidityPairs(prev => new Map(prev).set(tokenAddress, false));
        }
    }, [
        selectedLiquidityPairs,
        isFetchingLiquidityPairs,
        getLiquidityPairs,
        enrichLpTokenWithSymbols,
        tokenSelections,
        exploreDataCache,
        getTokenLogoUrl,
        fetchLpStats,
        account,
        LpCache,
        updateLpHoldingsCache,
    ]);

    // const ButtonGroup = React.memo(() => {
    //     return (
    //         <>
    //             <NextButton.Group color="primary" rounded ghost size="sm">
    //                 <NextButton clickable={false}>
    //                     {walletHoldings.length > 0 ?
    //                         <div>

    //                             Tokens <span>({walletHoldings.length})</span> -

    //                             {
    //                                 privacyMode
    //                                     ? ''
    //                                     : formatCurrencyExtended(totalWalletUSD)
    //                             }

    //                         </div>

    //                         : <Loading type="points" color="white" size="sm" />}
    //                 </NextButton>
    //                 <NextButton clickable={false}>
    //                     {!(isFetchingLp && !isDeepScan) ?
    //                         <div>
    //                             Liquidity <span>({lpHoldings.size})</span> -
    //                             {
    //                                 privacyMode
    //                                     ? ''
    //                                     : formatCurrencyExtended(totalLpValueUSD)
    //                             }
    //                         </div>
    //                         : <Loading type="points" color="white" size="sm" />}
    //                 </NextButton>
    //             </NextButton.Group>
    //         </>
    //     )
    // });

    const handleCopyAddress = () => {
        navigator.clipboard.writeText(account);
        toast.success(`Copied wallet address: ${account}`);
    };

    const TokenCountAndValue = () => {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginTop: '10px',
            }}>
                {/* Left Side: Tokens and Count */}
                <div style={{ fontSize: '18px', fontWeight: 'bold' }}>
                    Tokens <span style={{ fontSize: '14px', color: 'grey' }}>({walletHoldings.length})</span>
                </div>

                {/* Right Side: Total Wallet USD */}
                <div style={{ fontSize: '18px', fontWeight: 'bold' }}>
                    {
                        privacyMode
                            ? '*****'
                            : formatCurrencyExtended(totalWalletUSD)
                    }
                </div>
            </div>
        )
    }

    const LiquidityCountAndValue = () => {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginTop: '20px',
            }}>
                {/* Left Side: Liquidity and Count */}
                <div style={{ fontSize: '18px', fontWeight: 'bold' }}>
                    Liquidity <span style={{ fontSize: '14px', color: 'grey' }}>({lpHoldings.size})</span>
                </div>

                {/* Right Side: Total LP USD */}
                <div style={{ fontSize: '18px', fontWeight: 'bold' }}>
                    {
                        privacyMode
                            ? '*****'
                            : formatCurrencyExtended(totalLpValueUSD)
                    }
                </div>
            </div>
        )
    }


    return (
      <div style={containerStyle}>
        <div style={{ marginTop: "10px" }}>
          {/* TabView for "My Wallet", "My LP Holdings", and "Explore" */}
          <div
            style={{
              marginLeft: "-15px",
              marginRight: "-15px",
            }}
          >
            <PrimeTabView
              activeIndex={activeIndex}
              onTabChange={(e) => setActiveIndex(e.index)}
              renderActiveOnly={true}
            >
              {/* "My Wallet" Tab */}
              <PrimeTabPanel header="Wallet">
                {/* Wallet Header Bar*/}
                <div
                  style={{
                    display: "flex",
                    alignContent: "space-between",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "5px",
                    marginTop: "10px",
                    flexWrap: "wrap",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        gap: "5px",
                        flexWrap: "wrap",
                        alignItems: "center",
                      }}
                    >
                      {/* <button
                                            className="p-button p-component p-button-outlined p-button-sm p-button-text-icon-left"
                                            onClick={() => setShowHolderModal(true)}
                                        >
                                            <span className="p-button-icon p-c pi pi-user" />
                                   
                                        </button> */}

                      <TinyHolderCharts
                        holderAddress={holderAddress}
                        timeFrame={timeFrame}
                        onOpenHolderModal={() => setShowHolderModal(true)}
                        onClick
                      />

                      {/* Total Value */}
                      {totalLpValueUSD > 0 && (
                        <div
                          style={{
                            backgroundColor: "rgba(0, 0, 0, 0.05)",
                            borderRadius: "15px",
                            padding: "4px",
                          }}
                        >
                          <div
                            style={{ fontSize: "13px", fontWeight: "normal" }}
                          >
                            Total Value
                          </div>
                          <div style={{ fontSize: "16px", fontWeight: "bold" }}>
                            {privacyMode
                              ? "*****"
                              : formatCurrencyExtended(grandTotalUSD)}
                          </div>
                        </div>
                      )}

                      {/* Total Wallet Value */}
                      <div
                        style={{
                          backgroundColor: "rgba(0, 0, 0, 0.05)",
                          borderRadius: "15px",
                          padding: "4px",
                        }}
                      >
                        <div style={{ fontSize: "13px", fontWeight: "normal" }}>
                          Wallet Value
                        </div>
                        <div style={{ fontSize: "16px", fontWeight: "bold" }}>
                          {privacyMode
                            ? "*****"
                            : formatCurrencyExtended(totalWalletUSD)}
                        </div>
                      </div>

                      {/* Total LP Value */}
                      {totalLpValueUSD > 0 && (
                        <div
                          style={{
                            backgroundColor: "rgba(0, 0, 0, 0.05)",
                            borderRadius: "15px",
                            padding: "4px",
                          }}
                        >
                          <div
                            style={{ fontSize: "13px", fontWeight: "normal" }}
                          >
                            LP Value
                          </div>
                          <div style={{ fontSize: "16px", fontWeight: "bold" }}>
                            {privacyMode
                              ? "*****"
                              : formatCurrencyExtended(totalLpValueUSD)}
                          </div>
                        </div>
                      )}

                      {/* Connected Wallet */}
                      <div
                        style={{
                          fontSize: "12px",
                          fontWeight: "normal",
                          backgroundColor: "rgba(0, 0, 0, 0.05)",
                          borderRadius: "15px",
                          padding: "4px",
                          overflow: "auto",
                        }}
                      >
                        Connected Wallet <br />
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                            fontSize: "13px",
                            fontWeight: "bold",
                          }}
                        >
                          <Button
                            icon="pi pi-copy"
                            className="p-button-text"
                            onClick={handleCopyAddress}
                            label={formatWalletAddress(account)}
                            size="small"
                            style={{
                              padding: "0px",
                              fontSize: "13px",
                              fontWeight: "bold",
                            }}
                          />
                        </div>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "center",
                          gap: "5px",
                          flexGrow: 1, // Allow the container to grow and take up available space
                          flexBasis: "0", // Set the initial size to zero to allow flex-grow to take effect
                        }}
                      >
                        <Switch
                          checked={advancedView}
                          size="md"
                          onChange={handleAdvancedViewSwitch}
                          iconOn={<BarChartIcon />}
                          iconOff={<BarChartIcon />}
                          style={{ color: "black" }}
                        />
                        <Switch
                          checked={radarView}
                          size="md"
                          onChange={handleRadarViewSwitch}
                          iconOn={<RocketLaunchIcon />}
                          iconOff={<RadarIcon />}
                          style={{ color: "black" }}
                        />
                        <Switch
                          checked={!usdView}
                          size="md"
                          onChange={() => setUsdView((prev) => !prev)}
                          iconOff={<AttachMoneyIcon />}
                          iconOn={<CurrencyBitcoinIcon />}
                          style={{ color: "black" }}
                        />
                        <Switch
                          checked={privacyMode}
                          size="md"
                          onChange={handlePrivacyMode}
                          iconOn={<PrivacyIcon />}
                          iconOff={<PrivacyIcon />}
                          style={{ color: "black" }}
                        />
                        <Dropdown
                          value={timeFrame}
                          options={TIMEFRAME_OPTIONS}
                          onChange={(e) => setTimeFrame(e.value)}
                          style={{ minWidth: "100px" }}
                          placeholder="Timeframe"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  style={{
                    marginLeft: "-20px",
                    marginRight: "-20px",
                  }}
                >
                  <PrimeTabView
                  renderActiveOnly={true}
                  >
                    <PrimeTabPanel
                      header={
                        <span>
                          {" "}
                          Tokens{" "}
                          <span style={{ fontSize: "14px", color: "grey" }}>
                            ({walletHoldings.length})
                          </span>
                        </span>
                      }
                    >
                      {/* <TokenCountAndValue /> */}
                      <ScrollPanel
                        style={{
                          width: "100%",
                          height: "600px",
                          marginTop: "5px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "20px",
                            flexWrap: "wrap",
                          }}
                        >
                          <div style={{ flex: "1 1 60%", minWidth: "300px" }}>
                            {/* Token Cards */}
                            <div
                              style={{
                                flexDirection: "column",
                                display: "grid",
                                flexWrap: "wrap",
                                gridTemplateColumns:
                                  "repeat(auto-fill, minmax(300px, 1fr))",
                                justifyContent: "flex-start",
                                gap: advancedView ? "15px" : "2px",
                                paddingTop: "10px",
                              }}
                            >
                              {walletHoldings.length > 0 ? (
                                walletHoldings.map((token) => (
                                  <div key={token.address.toLowerCase()}>
                                    <NextCard
                                      key={token.address.toLowerCase()} // Use unique identifier
                                      isHoverable={!radarView}
                                      isPressable={!radarView}
                                      onClick={() =>
                                        handleTokenCardClick(token)
                                      }
                                      style={miniTokenCardStyle(advancedView)}
                                    >
                                      <NextCard.Body style={{ padding: "1px" }}>
                                        {/* Header Section */}
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                          }}
                                        >
                                          <div
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "10px",
                                              fontWeight: "bold",
                                              fontSize: "16px",
                                            }}
                                          >
                                            <img
                                              src={getTokenLogoUrl(token)}
                                              alt={token.symbol}
                                              style={{
                                                width: "25px",
                                                height: "25px",
                                              }}
                                            />
                                            <span>
                                              {token.symbol === "WBNB"
                                                ? "BNB"
                                                : token.symbol}
                                            </span>
                                          </div>

                                          {/* {
                                                                    advancedView && token.symbol !== "WBNB" && (
                                                                        <div style={{ width: '50px'}}>
                                                                            <TinyRadarChart token={token} tokenSelections={tokenSelections} />
                                                                        </div>
                                                                    )
                                                                } */}
                                          <div>
                                            {privacyMode ? (
                                              <div
                                                style={{
                                                  display: "flex",
                                                  flexDirection: "column",
                                                  alignItems: "flex-end",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    fontSize: "18px",
                                                    fontWeight: "bold",
                                                  }}
                                                >
                                                  <span>*****</span>
                                                </div>
                                              </div>
                                            ) : (
                                              <div
                                                style={{
                                                  display: "flex",
                                                  flexDirection: "column",
                                                  alignItems: "flex-end",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    fontSize: "18px",
                                                    fontWeight: "bold",
                                                  }}
                                                >
                                                  {usdView
                                                    ? formatCurrencyExtended(
                                                        token.balanceUSD
                                                      )
                                                    : formatDecimals(
                                                        token.balanceOfHolder,
                                                        token.decimals
                                                      )}
                                                </div>

                                                <div
                                                  style={{
                                                    fontSize: "14px",
                                                    color: "grey",
                                                  }}
                                                >
                                                  {!usdView
                                                    ? formatCurrencyExtended(
                                                        token.balanceUSD
                                                      )
                                                    : formatDecimals(
                                                        token.balanceOfHolder,
                                                        token.decimals
                                                      )}
                                                </div>
                                              </div>
                                            )}
                                          </div>
                                        </div>

                                        {/* Actions Section */}
                                        {radarView && (
                                          <div>
                                            <RewardsPending
                                              token={token}
                                              account={account}
                                              contracts={contracts}
                                              imageReferences={imageReferences}
                                              tokenSelections={tokenSelections}
                                              enableClaiming={true}
                                              refreshData={refreshData}
                                            />
                                          </div>
                                        )}

                                        {!advancedView && (
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              whiteSpace: "nowrap",
                                              marginTop: "5px",
                                              fontSize: "11px",
                                              paddingLeft: "8px",
                                              paddingRight: "8px",
                                              paddingTop: "5px",
                                              paddingBottom: "5px",
                                              color: "white",
                                              backgroundColor:
                                                "rgba(0, 0, 0, 0.90)",
                                              borderRadius: "10px",
                                            }}
                                          >
                                            <div
                                              style={{
                                                display: "flex",
                                                flexDirection: "row",
                                                justifyContent: "space-between",
                                                gap: "2px",
                                              }}
                                            >
                                              <span>Price:</span>
                                              <span
                                                style={{ whiteSpace: "pre" }}
                                              >
                                                {" "}
                                              </span>
                                              <strong>
                                                {formatCurrencyExtended(
                                                  token.price
                                                )}
                                              </strong>
                                            </div>
                                            {/* <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: '2px' }}>
                                                                                    <span>24h Vol:</span>
                                                                                    <span style={{ whiteSpace: 'pre' }}>{' '}</span>
                                                                                    <strong>{formatCurrencyExtended(token.volume24h)}</strong>
                                                                                </div> */}
                                            <div
                                              style={{
                                                display: "flex",
                                                flexDirection: "row",
                                                justifyContent: "space-between",
                                                gap: "2px",
                                              }}
                                            >
                                              <span>24h Change:</span>
                                              <span
                                                style={{ whiteSpace: "pre" }}
                                              >
                                                {" "}
                                              </span>
                                              <strong
                                                style={{
                                                  color:
                                                    token.averagePriceChange24h >
                                                    0
                                                      ? "rgb(177, 255, 167)"
                                                      : token.averagePriceChange24h <
                                                        0
                                                      ? "rgb(255, 160, 136)"
                                                      : "rgb(185, 185, 185)",
                                                }}
                                              >
                                                {formatPercentage(
                                                  token.averagePriceChange24h /
                                                    100
                                                )}
                                              </strong>
                                            </div>
                                          </div>
                                        )}
                                      </NextCard.Body>
                                    </NextCard>
                                    {advancedView && (
                                      <div
                                        style={{
                                          marginTop: "-20px",
                                          backgroundColor:
                                            "rgba(6, 0, 30, 0.9)",
                                          borderRadius: "10px",
                                          //outline: '1px solid rgba(255, 255, 255, 0.25)',
                                          paddingLeft: "7px",
                                          paddingRight: "7px",
                                          paddingBottom: "7px",
                                          paddingTop: "30px",
                                        }}
                                      >
                                        {/* <div style={{ width: '100%', marginTop: '10px' }}>
                                                                <TinyRadarChart token={token} tokenSelections={tokenSelections} />
                                                            </div> */}
                                        {token.chartingData &&
                                          token.chartingData.length > 0 && (
                                            <div
                                              style={{
                                                width: "100&",
                                                marginTop: "5px",
                                              }}
                                            >
                                              <Suspense fallback={<LoadingSmallContent />}>
                                                <NewTinyRadarChart
                                                  chartingData={
                                                    token.chartingData
                                                  }
                                                  tokenAddress={token.address.toLowerCase()}
                                                  timeframe={timeFrame}
                                                />
                                              </Suspense> 
                                            </div>
                                          )}
                                        <div
                                          style={{
                                            display: "grid",
                                            gridTemplateColumns:
                                              "repeat(auto-fill, minmax(95px, 1fr))",
                                            gap: "5px",
                                            fontSize: "10px",
                                            color: "white",
                                            //marginTop: '-45px',
                                          }}
                                        >
                                          {/* Market Cap */}
                                          {advancedView &&
                                            token.symbol !== "WBNB" && (
                                              <div
                                                style={{
                                                  display: "flex",
                                                  flexDirection: "column",
                                                  justifyContent:
                                                    "space-between",
                                                }}
                                              >
                                                <span>Market Cap:</span>
                                                {token.totalSupply !==
                                                undefined ? (
                                                  <strong>
                                                    {formatCurrencyExtended(
                                                      calculateMarketCap(
                                                        token.totalSupply,
                                                        token.decimals,
                                                        token.price
                                                      )
                                                    )}
                                                  </strong>
                                                ) : (
                                                  <LoadingSmallContent />
                                                )}
                                              </div>
                                            )}

                                          {/* Price */}
                                          <div
                                            style={{
                                              display: "flex",
                                              flexDirection: "column",
                                              justifyContent: "space-between",
                                            }}
                                          >
                                            <span>Price:</span>
                                            {token.price !== undefined ? (
                                              <strong>
                                                {formatCurrencyExtended(
                                                  token.price
                                                )}
                                              </strong>
                                            ) : (
                                              <LoadingSmallContent />
                                            )}
                                          </div>

                                          {/* Liquidity Backing */}
                                          {advancedView &&
                                            token.symbol !== "WBNB" && (
                                              <div
                                                style={{
                                                  display: "flex",
                                                  flexDirection: "column",
                                                  justifyContent:
                                                    "space-between",
                                                }}
                                              >
                                                <span>Liquidity Backing:</span>
                                                {token.liquidityBacking !==
                                                undefined ? (
                                                  <strong>
                                                    {formatPercentage(
                                                      token.liquidityBacking
                                                    )}
                                                  </strong>
                                                ) : (
                                                  <LoadingSmallContent />
                                                )}
                                              </div>
                                            )}

                                          {/* Liquidity Value */}
                                          {advancedView &&
                                            token.symbol !== "WBNB" && (
                                              <div
                                                style={{
                                                  display: "flex",
                                                  flexDirection: "column",
                                                  justifyContent:
                                                    "space-between",
                                                }}
                                              >
                                                <span>Liquidity Value:</span>
                                                {token.liquidityValue !==
                                                undefined ? (
                                                  <strong>
                                                    {formatCurrencyExtended(
                                                      token.liquidityValue
                                                    )}
                                                  </strong>
                                                ) : (
                                                  <LoadingSmallContent />
                                                )}
                                              </div>
                                            )}

                                          {/* Volume (24hr) */}
                                          <div
                                            style={{
                                              display: "flex",
                                              flexDirection: "column",
                                              justifyContent: "space-between",
                                            }}
                                          >
                                            <span>Volume (24hr):</span>
                                            {token.volume24h !== undefined ? (
                                              <strong>
                                                {formatCurrencyExtended(
                                                  token.volume24h
                                                )}
                                              </strong>
                                            ) : (
                                              <LoadingSmallContent />
                                            )}
                                          </div>

                                          {/* Average Price Change (24h) */}
                                          <div
                                            style={{
                                              display: "flex",
                                              flexDirection: "column",
                                              justifyContent: "space-between",
                                            }}
                                          >
                                            <span>Price Change (24h):</span>
                                            {token.averagePriceChange24h !==
                                            undefined ? (
                                              <strong
                                                style={{
                                                  color:
                                                    token.averagePriceChange24h >
                                                    0
                                                      ? "green"
                                                      : token.averagePriceChange24h <
                                                        0
                                                      ? "red"
                                                      : "grey",
                                                }}
                                              >
                                                {formatPercentage(
                                                  token.averagePriceChange24h /
                                                    100
                                                )}
                                              </strong>
                                            ) : (
                                              <LoadingSmallContent />
                                            )}
                                          </div>

                                          {/* Buys (24hr) */}
                                          {advancedView && (
                                            <div
                                              style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: "space-between",
                                              }}
                                            >
                                              <span>Buys (24hr):</span>
                                              {token.totalBuys24h !==
                                              undefined ? (
                                                <strong>
                                                  {token.totalBuys24h}
                                                </strong>
                                              ) : (
                                                <LoadingSmallContent />
                                              )}
                                            </div>
                                          )}

                                          {/* Sells (24hr) */}
                                          {advancedView && (
                                            <div
                                              style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: "space-between",
                                              }}
                                            >
                                              <span>Sells (24hr):</span>
                                              {token.totalSells24h !==
                                              undefined ? (
                                                <strong>
                                                  {token.totalSells24h}
                                                </strong>
                                              ) : (
                                                <LoadingSmallContent />
                                              )}
                                            </div>
                                          )}
                                          {/* Token Address */}
                                          <div
                                            style={{
                                              display: "flex",
                                              flexDirection: "column",
                                              justifyContent: "space-between",
                                            }}
                                          >
                                            <span>Token Address:</span>
                                            <div
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "5px",
                                              }}
                                            >
                                              <strong>
                                                {formatWalletAddress(
                                                  token.address
                                                )}
                                              </strong>
                                              <IconButton
                                                style={{ padding: 0 }}
                                                onClick={() => {
                                                  navigator.clipboard.writeText(
                                                    token.address
                                                  );
                                                  toast.success(
                                                    `Copied to clipboard: ${token.address}`
                                                  );
                                                }}
                                              >
                                                <ContentCopyIcon
                                                  style={{
                                                    fontSize: "14px",
                                                    cursor: "pointer",
                                                    color: "white",
                                                  }}
                                                />
                                              </IconButton>
                                            </div>
                                          </div>
                                        </div>
                                        {/* <ArbiScanSwapButton
                                          token={token}
                                          provider={library?.provider}
                                          getLiquidityPairs={getLiquidityPairs}
                                        />
                                       <QuickSwap
                                        token={token}
                                        bnbBalance={bnbBalance}
                                        walletAddress={account}
                                        getLiquidityPairs={getLiquidityPairs}
                                     
                                        bnbPrice={bnbPrice}
                                        getTokenLogoUrl={getTokenLogoUrl}
                                    />
                                      <SmartArbiSwap
                                        token={token}
                                        bnbBalance={bnbBalance}
                                        walletAddress={account}
                                        getLiquidityPairs={getLiquidityPairs}
                                        bnbPrice={bnbPrice}
                                        getTokenLogoUrl={getTokenLogoUrl}
                                    /> */}


                                      </div>
                                    )}
                                  </div>
                                ))
                              ) : (
                                <LoadingContent />
                              )}
                            </div>
                          </div>
                          {/* {//!radarView && 
                                    walletHoldings.length > 0 &&
                                    <div style={{ flex: '1 1 35%', minWidth: '300px', marginTop: '-10px' }}>
                                      
                                        <RadarChartComponent walletHoldings={walletHoldings} token_categories={token_categories} />
                                    </div>} */}
                        </div>
                      </ScrollPanel>
                    </PrimeTabPanel>
                    <PrimeTabPanel
                      header={
                        <span>
                          {" "}
                          Liquidity{" "}
                          <span style={{ fontSize: "14px", color: "grey" }}>
                            ({lpHoldings.size})
                          </span>
                        </span>
                      }
                    >
                      {/* <LiquidityCountAndValue /> */}
                      <ScrollPanel
                        style={{
                          width: "100%",
                          height: "550px",
                          marginTop: "5px",
                        }}
                      >
                        <div>
                          {isFetchingLp && !isDeepScan && (
                            <div
                              style={{ color: "blue", marginBottom: "10px" }}
                            >
                              Refreshing LP tokens...
                            </div>
                          )}
                          {!isFetchingLp &&
                            !isDeepScan &&
                            lpHoldings.size === 0 && (
                              <span>No LP holdings found.</span>
                            )}

                          {lpHoldings.size > 0 && (
                            <div>
                              {/* If isDeepScan or isFetchingLp is true, you can show a small spinner. */}
                              {isDeepScan && (
                                <span style={{ color: "red" }}>
                                  Scanning additional LP tokens...
                                </span>
                              )}

                              {Object.keys(groupedLpTokens).map((groupKey) => (
                                <div key={groupKey}>
                                  {groupBy !== "none" && (
                                    <h3
                                      style={{
                                        fontSize: "18px",
                                        fontWeight: "bold",
                                        marginTop: "20px",
                                      }}
                                    >
                                      {groupKey} Pairs
                                    </h3>
                                  )}
                                  <div
                                    style={{
                                      display: "grid",
                                      flexDirection: "column",
                                      flexWrap: "wrap",
                                      gridTemplateColumns:
                                        "repeat(auto-fill, minmax(300px, 1fr))", // Adjusted min width
                                      justifyContent: "flex-start",
                                      gap: "5px",
                                      paddingTop: "10px",
                                    }}
                                  >
                                    {groupedLpTokens[groupKey].map(
                                      (lpToken) => {
                                        const pairAddrLower =
                                          lpToken.pairAddress.toLowerCase();
                                        const isLoading =
                                          loadingLpPairs.has(pairAddrLower);

                                        return (
                                          <LpTokenCard
                                            key={lpToken.pairAddress.toLowerCase()}
                                            lpToken={lpToken}
                                            showSkeleton={isLoading}
                                            onApproxUsdValueChange={
                                              handleApproxUsdValueChange
                                            }
                                            handleLpTokenCardClick={(lp) => {
                                              // For pressable = true, open the LP Manage Modal
                                              if (!radarView) {
                                                setLpModalsOpen((prev) => ({
                                                  ...prev,
                                                  [lp.pairAddress.toLowerCase()]: true,
                                                }));
                                              }
                                            }}
                                            usdView={usdView}
                                            privacyMode={privacyMode}
                                            advancedView={advancedView}
                                            tokenSelections={tokenSelections}
                                            pressable={!radarView}
                                            getTokenLogoUrl={getTokenLogoUrl}
                                            radarView={radarView}
                                            imageReferences={imageReferences}
                                            contracts={contracts}
                                          />
                                        );
                                      }
                                    )}
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </ScrollPanel>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginTop: "15px",
                          gap: "10px",
                          flexWrap: "wrap",
                          border: "1px solid rgba(0, 0, 0, 0.1)",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                          
                            gap: "10px",
                          }}
                        >
                          <label htmlFor="groupBy">Group By:</label>
                          <select
                            id="groupBy"
                            value={groupBy}
                            onChange={handleGroupByChange}
                            style={{
                              padding: "10px",
                              fontSize: "16px",
                              borderRadius: "8px",
                              border: "1px solid #ccc",
                              minWidth: "100px",
                            }}
                          >
                            <option value="none">None</option>
                            <option value="token">Token</option>
                            <option value="dex">Dex</option>
                          </select>
                      

                            <Button
                                      onClick={async () => {
                                        try {
                                          setMultiSyncing(true);
                                          await syncMultiplePairs({
                                            provider: library.provider,
                                            account,
                                            pairs: Array.from(lpHoldings.keys()),
                                          });
                                          alert('Sync successful');
                                        } catch (err) {
                                          console.error('sync error', err);
                                          alert('Sync failed - see console');
                                        } finally {
                                          setMultiSyncing(false);
                                        }
                                      }}
                                      disabled={multiSyncing || isDeepScan || isFetchingLp}
                                      size="large"
                                      icon={multiSyncing ? "pi pi-spin pi-refresh" : "pi pi-sync"}
                                      className="p-button-outlined"
                                      style={{
                                        padding:'10px 10px 10px 10px',
                                       
                                        border:'none',
                                        borderRadius:'15px',
                                        fontSize:'16px',
                                        cursor: multiSyncing ? 'not-allowed' : 'pointer',
                                        width: '100%',
                                        maxWidth: '250px',
                                        alignSelf: 'center',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                      }}
                                    >
                                      {multiSyncing ? 'Syncing On Chain…' : 'Sync All LP OnChain'}
                                    </Button>

                        
                          </div>
                          {/* Deep Scan Button */}
                        <Button
                          label={isDeepScan ? `Scanning...` : "Deep Scan"}
                          icon={
                            isDeepScan
                              ? "pi pi-spin pi-refresh"
                              : "pi pi-refresh"
                          }
                          onClick={performDeepScan}
                          disabled={isDeepScan || isFetchingLp}
                          style={{
                            padding: "10px 20px",
                            borderRadius: "25px",
                            backgroundColor:
                              isDeepScan || isFetchingLp ? "#ccc" : "#007bff",
                            color: "#fff",
                            border: "none",
                            cursor:
                              isDeepScan || isFetchingLp
                                ? "not-allowed"
                                : "pointer",
                          }}
                        />
                      </div>
                    </PrimeTabPanel>
                  </PrimeTabView>
                </div>
              </PrimeTabPanel>

              {/* "Explore" Tab */}
              <PrimeTabPanel header="Explore">
                {/* Wallet Header Bar*/}
                <div
                  style={{
                    display: "flex",
                    alignContent: "space-between",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "5px",
                    marginTop: "10px",
                    flexWrap: "wrap",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        gap: "5px",
                        flexWrap: "wrap",
                      }}
                    >
                      {/* Total Value */}
                      <div
                        style={{
                          backgroundColor: "rgba(0, 0, 0, 0.05)",
                          borderRadius: "15px",
                          padding: "5px",
                        }}
                      >
                        <div style={{ fontSize: "14px", fontWeight: "normal" }}>
                          Total Value
                        </div>
                        <div style={{ fontSize: "18px", fontWeight: "bold" }}>
                          {privacyMode
                            ? "*****"
                            : formatCurrencyExtended(grandTotalUSD)}
                        </div>
                      </div>

                      {/* Total Wallet Value */}
                      <div
                        style={{
                          backgroundColor: "rgba(0, 0, 0, 0.05)",
                          borderRadius: "15px",
                          padding: "5px",
                        }}
                      >
                        <div style={{ fontSize: "14px", fontWeight: "normal" }}>
                          Wallet Value
                        </div>
                        <div style={{ fontSize: "18px", fontWeight: "bold" }}>
                          {privacyMode
                            ? "*****"
                            : formatCurrencyExtended(totalWalletUSD)}
                        </div>
                      </div>

                      {/* Total LP Value */}
                      <div
                        style={{
                          backgroundColor: "rgba(0, 0, 0, 0.05)",
                          borderRadius: "15px",
                          padding: "5px",
                        }}
                      >
                        <div style={{ fontSize: "14px", fontWeight: "normal" }}>
                          LP Value
                        </div>
                        <div style={{ fontSize: "18px", fontWeight: "bold" }}>
                          {privacyMode
                            ? "*****"
                            : formatCurrencyExtended(totalLpValueUSD)}
                        </div>
                      </div>

                      {/* Connected Wallet */}
                      <div
                        style={{
                          fontSize: "14px",
                          fontWeight: "normal",
                          backgroundColor: "rgba(0, 0, 0, 0.05)",
                          borderRadius: "15px",
                          padding: "5px",
                          overflow: "auto",
                        }}
                      >
                        Connected Wallet <br />
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                            fontSize: "14px",
                            fontWeight: "bold",
                          }}
                        >
                          <Button
                            icon="pi pi-copy"
                            className="p-button-text"
                            onClick={handleCopyAddress}
                            label={formatWalletAddress(account)}
                            size="small"
                            style={{
                              padding: "0px",
                              fontSize: "14px",
                              fontWeight: "bold",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    gap: "5px",
                    alignSelf: "flex-end",
                  }}
                >
                  <Switch
                    checked={advancedView}
                    size="md"
                    onChange={handleAdvancedViewSwitch}
                    iconOn={<BarChartIcon />}
                    iconOff={<BarChartIcon />}
                    style={{ color: "black" }}
                  />
                  <Switch
                    checked={radarView}
                    size="md"
                    onChange={handleRadarViewSwitch}
                    iconOn={<RocketLaunchIcon />}
                    iconOff={<RadarIcon />}
                    style={{ color: "black" }}
                  />
                  <Switch
                    checked={!usdView}
                    size="md"
                    onChange={() => setUsdView((prev) => !prev)}
                    iconOff={<AttachMoneyIcon />}
                    iconOn={<CurrencyBitcoinIcon />}
                    style={{ color: "black" }}
                  />
                  <Switch
                    checked={privacyMode}
                    size="md"
                    onChange={handlePrivacyMode}
                    iconOn={<PrivacyIcon />}
                    iconOff={<PrivacyIcon />}
                    style={{ color: "black" }}
                  />
                </div>
                <div
                  style={{
                    marginBottom: "20px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                    marginTop: "15px",
                  }}
                >
                  {/* Search Input and Clear Button */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      flexWrap: "wrap",
                      width: "100%",
                    }}
                  >
                    <input
                      type="text"
                      placeholder="Search by name, symbol, or address..."
                      value={searchQueryExplore}
                      onChange={handleSearchQueryChange}
                      style={{
                        padding: "10px",
                        borderRadius: "8px",
                        border: "1px solid #ccc",
                        fontSize: "16px",
                        flex: "1", // Responsive width
                        minWidth: "150px",
                      }}
                    />
                    <Button
                      label="Clear"
                      onClick={() => {
                        setSearchQueryExplore("");
                        localStorage.setItem("searchQueryExplore", ""); // Clear from localStorage
                      }}
                      style={{
                        minWidth: "80px", // Button size
                        borderRadius: "15px", // Rounded corners
                      }}
                    />
                  </div>

                  {/* Select Dropdown and Pagination Controls */}
                  <div
                    style={{
                      marginTop: "10px",
                      display: "flex",
                      flexWrap: "wrap", // Allow wrapping in smaller screens
                      gap: "10px", // Space between elements
                      width: "100%",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    {/* Select Dropdown */}
                    <select
                      value={sortCriteriaExplore}
                      onChange={handleSortCriteriaChange}
                      style={{
                        padding: "10px",
                        fontSize: "16px",
                        borderRadius: "8px",
                        border: "1px solid #ccc",
                        flex: "1",
                        minWidth: "150px",
                      }}
                    >
                      <option value="marketCap" key="marketCap">
                        Market Cap
                      </option>
                      <option value="totalSupply" key="totalSupply">
                        Total Supply
                      </option>
                      <option value="liquidityBacking" key="liquidityBacking">
                        Liquidity Backing
                      </option>
                      <option value="liquidityValue" key="liquidityValue">
                        Liquidity Value
                      </option>
                      <option value="volume24h" key="volume24h">
                        Volume (24hr)
                      </option>
                    </select>

                    {/* Sort Order Toggle Button */}
                    <Button
                      label={sortOrderExplore === "asc" ? "Asc ↑" : "Desc ↓"}
                      onClick={() =>
                        setSortOrderExplore(
                          sortOrderExplore === "asc" ? "desc" : "asc"
                        )
                      }
                      style={{
                        padding: "10px",
                        minWidth: "80px",
                        borderRadius: "15px",
                      }}
                    />

                    {/* Page Number Info */}
                    <div
                      style={{
                        flex: "1",
                        textAlign: "center",
                        minWidth: "150px",
                      }}
                    >
                      Page {currentPageExplore} of{" "}
                      {Math.ceil(tokenSelections?.length / itemsPerPageExplore)}
                    </div>

                    {/* Pagination Buttons */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flex: "1", // Responsive layout for buttons
                        gap: "10px",
                      }}
                    >
                      <Button
                        label="Previous"
                        disabled={currentPageExplore === 1}
                        onClick={() =>
                          setCurrentPageExplore((prev) => Math.max(prev - 1, 1))
                        }
                        style={{ minWidth: "80px", borderRadius: "15px" }}
                      />
                      <Button
                        label="Next"
                        disabled={
                          currentPageExplore ===
                          Math.ceil(
                            tokenSelections?.length / itemsPerPageExplore
                          )
                        }
                        onClick={() =>
                          setCurrentPageExplore((prev) =>
                            Math.min(
                              prev + 1,
                              Math.ceil(
                                tokenSelections?.length / itemsPerPageExplore
                              )
                            )
                          )
                        }
                        style={{ minWidth: "80px", borderRadius: "15px" }}
                      />
                    </div>
                  </div>
                </div>

                {/* Token Cards */}
                <ScrollPanel
                  style={{
                    width: "100%",
                    height: "600px",
                    marginTop: "5px",
                  }}
                >
                  <div
                    style={{
                      flexDirection: "column",
                      display: "grid",
                      flexWrap: "wrap",
                      gridTemplateColumns:
                        "repeat(auto-fill, minmax(300px, 1fr))",
                      justifyContent: "flex-start",
                      gap: "10px",
                    }}
                  >
                    {tokenSelections?.length > 0 ? (
                      // Filter tokens based on search query
                      tokenSelections
                        .filter((token) => {
                          const query = deferredSearchQuery.toLowerCase();
                          return (
                            token.name.toLowerCase().includes(query) ||
                            token.label.toLowerCase().includes(query) ||
                            token.value.toLowerCase().includes(query)
                          );
                        })
                        .sort((a, b) => {
                          let comparison = 0;

                          // Access cached data for enriched fields
                          const cachedA = exploreDataCache.get(
                            a.value.toLowerCase()
                          );
                          const cachedB = exploreDataCache.get(
                            b.value.toLowerCase()
                          );

                          switch (sortCriteriaExplore) {
                            case "marketCap":
                              const marketCapA = calculateMarketCap(
                                a.totalSupply,
                                a.decimals,
                                a.price
                              );
                              const marketCapB = calculateMarketCap(
                                b.totalSupply,
                                b.decimals,
                                b.price
                              );
                              comparison = marketCapA - marketCapB;
                              break;

                            case "totalSupply":
                              const totalSupplyA = new BigNumber(
                                a.totalSupply
                              ).dividedBy(new BigNumber(10).pow(a.decimals));
                              const totalSupplyB = new BigNumber(
                                b.totalSupply
                              ).dividedBy(new BigNumber(10).pow(b.decimals));
                              comparison = totalSupplyA
                                .minus(totalSupplyB)
                                .toNumber();
                              break;

                            case "liquidityBacking":
                              const liquidityBackingA =
                                cachedA?.liquidityBacking || 0;
                              const liquidityBackingB =
                                cachedB?.liquidityBacking || 0;
                              comparison =
                                liquidityBackingA - liquidityBackingB;
                              break;

                            case "liquidityValue":
                              const liquidityValueA =
                                cachedA?.liquidityValue || 0;
                              const liquidityValueB =
                                cachedB?.liquidityValue || 0;
                              comparison = liquidityValueA - liquidityValueB;
                              break;

                            case "volume24h":
                              const volumeA = cachedA?.volume24h || 0;
                              const volumeB = cachedB?.volume24h || 0;
                              comparison = volumeA - volumeB;
                              break;

                            default:
                              comparison = 0;
                          }

                          // If sortOrderExplore is 'desc', reverse the comparison
                          return sortOrderExplore === "asc"
                            ? comparison
                            : -comparison;
                        })
                        .slice(
                          (currentPageExplore - 1) * itemsPerPageExplore,
                          currentPageExplore * itemsPerPageExplore
                        )
                        .map((token) => {
                          const tokenAddress = token.value.toLowerCase();
                          const cachedData = exploreDataCache.get(tokenAddress);

                          return (
                            <div key={token.value.toLowerCase()}>
                              <NextCard
                                key={token.value.toLowerCase()}
                                isHoverable={!radarView}
                                isPressable={!radarView}
                                onClick={() => handleTokenCardClick(token)}
                                style={miniTokenCardStyle(advancedView)}
                              >
                                <NextCard.Body
                                  style={{ padding: "3px", overflow: "auto" }}
                                >
                                  {/* Header Section */}

                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "10px",
                                        fontWeight: "bold",
                                        fontSize: "20px",
                                      }}
                                    >
                                      <img
                                        src={getTokenLogoUrl(token)}
                                        alt={token.label}
                                        style={{
                                          width: "30px",
                                          height: "30px",
                                        }}
                                      />
                                      <span>
                                        {token.label === "WBNB"
                                          ? "BNB"
                                          : token.label}
                                      </span>
                                    </div>
                                    <div>
                                      {privacyMode ? (
                                        // ================ PRIVACY ENABLED ================
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "flex-end",
                                          }}
                                        >
                                          <div
                                            style={{
                                              fontSize: "18px",
                                              fontWeight: "bold",
                                            }}
                                          >
                                            <span>*****</span>
                                          </div>
                                        </div>
                                      ) : (
                                        // ================ SHOW REAL BALANCES ================
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "flex-end",
                                          }}
                                        >
                                          <div
                                            style={{
                                              fontSize: "18px",
                                              fontWeight: "bold",
                                            }}
                                          >
                                            {usdView
                                              ? formatCurrencyExtended(
                                                  token.balanceUSD
                                                )
                                              : formatDecimals(
                                                  token.balanceOfHolder,
                                                  token.decimals
                                                )}
                                          </div>

                                          <div
                                            style={{
                                              fontSize: "14px",
                                              color: "grey",
                                            }}
                                          >
                                            {!usdView
                                              ? formatCurrencyExtended(
                                                  token.balanceUSD
                                                )
                                              : formatDecimals(
                                                  token.balanceOfHolder,
                                                  token.decimals
                                                )}
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </div>

                                  {/* Actions Section */}
                                  {radarView && (
                                    <div>
                                      <RewardsPending
                                        token={token}
                                        account={account}
                                        contracts={contracts}
                                        imageReferences={imageReferences}
                                        tokenSelections={tokenSelections}
                                        enableClaiming={true}
                                      />
                                    </div>
                                  )}
                                  {!advancedView && (
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        marginTop: "5px",
                                        fontSize: "11px",
                                        paddingLeft: "8px",
                                        paddingRight: "8px",
                                        paddingTop: "5px",
                                        paddingBottom: "5px",
                                        color: "white",
                                        backgroundColor: "rgba(0, 0, 0, 0.90)",
                                        borderRadius: "10px",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "row",
                                          justifyContent: "space-between",
                                          gap: "2px",
                                        }}
                                      >
                                        <span>Price:</span>
                                        <span style={{ whiteSpace: "pre" }}>
                                          {" "}
                                        </span>
                                        <strong>
                                          {formatCurrencyExtended(token.price)}
                                        </strong>
                                      </div>

                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "row",
                                          justifyContent: "space-between",
                                          gap: "2px",
                                        }}
                                      >
                                        <span>24h Change:</span>
                                        <span style={{ whiteSpace: "pre" }}>
                                          {" "}
                                        </span>
                                        {cachedData?.averagePriceChange24h !==
                                        undefined ? (
                                          <strong
                                            style={{
                                              color:
                                                cachedData?.averagePriceChange24h >
                                                0
                                                  ? "rgb(177, 255, 167)"
                                                  : cachedData?.averagePriceChange24h <
                                                    0
                                                  ? "rgb(255, 160, 136)"
                                                  : "rgb(185, 185, 185)",
                                            }}
                                          >
                                            {formatPercentage(
                                              cachedData.averagePriceChange24h /
                                                100
                                            )}
                                          </strong>
                                        ) : (
                                          <LoadingSmallContent />
                                        )}
                                      </div>
                                    </div>
                                  )}
                                </NextCard.Body>
                              </NextCard>
                              {/* Liquidity Details */}
                              {advancedView && (
                                <div
                                  style={{
                                    marginTop: "-20px",
                                    backgroundColor:
                                      "rgba(255, 255, 255, 0.10)",
                                    borderRadius: "10px",
                                    //outline: '1px solid rgba(255, 255, 255, 0.25)',
                                    paddingLeft: "7px",
                                    paddingRight: "7px",
                                    paddingBottom: "7px",
                                    paddingTop: "30px",
                                  }}
                                >
                                  {/* <div style={{ width: '100%', marginTop: '10px' }}>
                                                                <TinyRadarChart token={token} tokenSelections={tokenSelections} />
                                                            </div> */}
                                  <div
                                    style={{
                                      display: "grid",
                                      gridTemplateColumns:
                                        "repeat(auto-fill, minmax(100px, 1fr))",
                                      gap: "5px",
                                      fontSize: "10px",
                                      color: "white",
                                      //marginTop: '-45px',
                                    }}
                                  >
                                    {/* Market Cap */}
                                    {advancedView &&
                                      token.symbol !== "WBNB" && (
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "space-between",
                                          }}
                                        >
                                          <span>Market Cap:</span>
                                          {token.totalSupply !== undefined ? (
                                            <strong>
                                              {formatCurrencyExtended(
                                                calculateMarketCap(
                                                  token.totalSupply,
                                                  token.decimals,
                                                  token.price
                                                )
                                              )}
                                            </strong>
                                          ) : (
                                            <LoadingSmallContent />
                                          )}
                                        </div>
                                      )}

                                    {/* Price */}
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      <span>Price:</span>
                                      {token.price !== undefined ? (
                                        <strong>
                                          {formatCurrencyExtended(token.price)}
                                        </strong>
                                      ) : (
                                        <LoadingSmallContent />
                                      )}
                                    </div>

                                    {/* Liquidity Backing */}
                                    {advancedView &&
                                      token.symbol !== "WBNB" && (
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "space-between",
                                          }}
                                        >
                                          <span>Liquidity Backing:</span>
                                          {cachedData?.liquidityBacking !==
                                          undefined ? (
                                            <strong>
                                              {formatPercentage(
                                                cachedData.liquidityBacking
                                              )}
                                            </strong>
                                          ) : (
                                            <LoadingSmallContent />
                                          )}
                                        </div>
                                      )}

                                    {/* Liquidity Value */}
                                    {advancedView &&
                                      token.symbol !== "WBNB" && (
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "space-between",
                                          }}
                                        >
                                          <span>Liquidity Value:</span>
                                          {cachedData?.liquidityValue !==
                                          undefined ? (
                                            <strong>
                                              {formatCurrencyExtended(
                                                cachedData?.liquidityValue
                                              )}
                                            </strong>
                                          ) : (
                                            <LoadingSmallContent />
                                          )}
                                        </div>
                                      )}

                                    {/* Volume (24hr) */}
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      <span>Volume (24hr):</span>
                                      {cachedData?.volume24h !== undefined ? (
                                        <strong>
                                          {formatCurrencyExtended(
                                            cachedData?.volume24h
                                          )}
                                        </strong>
                                      ) : (
                                        <LoadingSmallContent />
                                      )}
                                    </div>

                                    {/* Average Price Change (24h) */}
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      <span>Price Change (24h):</span>
                                      {cachedData?.averagePriceChange24h !==
                                      undefined ? (
                                        <strong
                                          style={{
                                            color:
                                              cachedData?.averagePriceChange24h >
                                              0
                                                ? "green"
                                                : cachedData?.averagePriceChange24h <
                                                  0
                                                ? "red"
                                                : "grey",
                                          }}
                                        >
                                          {formatPercentage(
                                            cachedData.averagePriceChange24h /
                                              100
                                          )}
                                        </strong>
                                      ) : (
                                        <LoadingSmallContent />
                                      )}
                                    </div>

                                    {/* Buys (24hr) */}
                                    {advancedView && (
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                          justifyContent: "space-between",
                                        }}
                                      >
                                        <span>Buys (24hr):</span>
                                        {cachedData?.totalBuys24h !==
                                        undefined ? (
                                          <strong>
                                            {cachedData?.totalBuys24h}
                                          </strong>
                                        ) : (
                                          <LoadingSmallContent />
                                        )}
                                      </div>
                                    )}

                                    {/* Sells (24hr) */}
                                    {advancedView && (
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                          justifyContent: "space-between",
                                        }}
                                      >
                                        <span>Sells (24hr):</span>
                                        {cachedData?.totalSells24h !==
                                        undefined ? (
                                          <strong>
                                            {cachedData?.totalSells24h}
                                          </strong>
                                        ) : (
                                          <LoadingSmallContent />
                                        )}
                                      </div>
                                    )}

                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      <span>Token Address:</span>
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "5px",
                                        }}
                                      >
                                        <strong>
                                          {formatWalletAddress(token.address)}
                                        </strong>
                                        <IconButton
                                          style={{ padding: 0 }}
                                          onClick={() => {
                                            navigator.clipboard.writeText(
                                              token.address
                                            );
                                            toast.success(
                                              `Copied to clipboard: ${token.address}`
                                            );
                                          }}
                                        >
                                          <ContentCopyIcon
                                            style={{
                                              fontSize: "14px",
                                              cursor: "pointer",
                                              color: "white",
                                            }}
                                          />
                                        </IconButton>
                                      </div>
                                    </div>
                                  </div>
                                  {advancedView && (
                                    <Button
                                      label={
                                        selectedLiquidityPairs.has(
                                          token.address.toLowerCase()
                                        )
                                          ? "Hide Liquidity Pairs"
                                          : "View Liquidity Pairs"
                                      }
                                      onClick={() =>
                                        handleViewLiquidityPairs(token)
                                      }
                                      style={{
                                        marginTop: "10px",
                                        padding: "4px 8px",
                                        borderRadius: "12px",
                                        backgroundColor:
                                          selectedLiquidityPairs.has(
                                            token.address.toLowerCase()
                                          )
                                            ? "#ff4d4f"
                                            : "#007bff",
                                        color: "#fff",
                                        border: "none",
                                        cursor: "pointer",
                                        alignSelf: "flex-end",
                                        fontSize: "12px",
                                      }}
                                    />
                                  )}
                                </div>
                              )}
                            </div>
                          );
                        })
                    ) : (
                      <LoadingContent />
                    )}
                  </div>
                </ScrollPanel>
              </PrimeTabPanel>
            </PrimeTabView>
          </div>
        </div>

        {/* Liquidity Pairs Modals */}
        {Array.from(selectedLiquidityPairs.entries()).map(
          ([tokenAddress, liquidityPairs]) => {
            const showThisModal = true;
            const tokenLabel =
              tokenSelections.find(
                (t) => t.value.toLowerCase() === tokenAddress.toLowerCase()
              )?.label || "Unknown Token";

            return (
              <Dialog
                key={tokenAddress}
                header={
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <h3
                      style={{
                        fontSize: "20px",
                        marginBottom: "10px",
                        marginTop: "5px",
                      }}
                    >
                      {tokenLabel} Liquidity Pairs
                    </h3>
                  </div>
                }
                visible={showThisModal}
                modal={false}
                style={{
                  width: "800px",
                  borderRadius: "15px",
                  height: "100%",
                }}
                onHide={() => {
                  setSelectedLiquidityPairs((prev) => {
                    const newMap = new Map(prev);
                    newMap.delete(tokenAddress);
                    return newMap;
                  });
                }}
                maximizable
                footer={
                  liquidityPairs.length > itemsPerPageSelected && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "10px",
                      }}
                    >
                      <Button
                        label="Previous"
                        disabled={
                          !selectedLiquidityPage[tokenAddress] ||
                          selectedLiquidityPage[tokenAddress] === 1
                        }
                        onClick={() =>
                          handleSelectedLiquidityPageChange(
                            tokenAddress,
                            (selectedLiquidityPage[tokenAddress] || 1) - 1
                          )
                        }
                        style={{ marginRight: "10px" }}
                      />
                      <Button
                        label="Next"
                        disabled={
                          selectedLiquidityPage[tokenAddress] ===
                          Math.ceil(
                            liquidityPairs.length / itemsPerPageSelected
                          )
                        }
                        onClick={() =>
                          handleSelectedLiquidityPageChange(
                            tokenAddress,
                            (selectedLiquidityPage[tokenAddress] || 1) + 1
                          )
                        }
                      />
                    </div>
                  )
                }
              >
                {/* The body of your old <div> goes here */}

                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns:
                      "repeat(auto-fill, minmax(300px, 1fr))",
                    gap: "10px",
                  }}
                >
                  {liquidityPairs
                    .slice(
                      (selectedLiquidityPage[tokenAddress] - 1) *
                        itemsPerPageSelected,
                      selectedLiquidityPage[tokenAddress] * itemsPerPageSelected
                    )
                    .map((lpToken) => (
                      <LpTokenCard
                        key={lpToken.pairAddress.toLowerCase()}
                        lpToken={lpToken}
                        onApproxUsdValueChange={handleApproxUsdValueChange}
                        handleLpTokenCardClick={(lp) => {
                          // For pressable = true, open the LP Manage Modal
                          if (!radarView) {
                            setLpModalsOpen((prev) => ({
                              ...prev,
                              [lp.pairAddress.toLowerCase()]: true,
                            }));
                          }
                        }}
                        usdView={usdView}
                        privacyMode={privacyMode}
                        advancedView={advancedView}
                        tokenSelections={tokenSelections}
                        pressable={!radarView}
                        getTokenLogoUrl={getTokenLogoUrl}
                        imageReferences={imageReferences}
                        contracts={contracts}
                      />
                    ))}
                </div>
              </Dialog>
            );
          }
        )}

        {/* Token Info Modals */}
        {Object.keys(openModals).map((address) => {
          const maximize = Object.keys(openModals).length <= 1; // Maximize modal if only one is open
          if (openModals[address]) {
            const token =
              walletHoldings?.find(
                (t) => t.address.toLowerCase() === address
              ) ||
              tokenSelections?.find((t) => t.value.toLowerCase() === address); // Check tokenSelections too
            return (
              <TokenInfoModal
                key={address}
                token={token} // Ensure token data is passed correctly
                onClose={createCloseHandler(address)}
                fetchTokenDetails={fetchTokenDetails}
                maximize={maximize}
                bnbPrice={bnbPrice}
                tokenSelections={tokenSelections}
              />
            );
          } else {
            return null;
          }
        })}

        {Object.keys(lpModalsOpen).map((pairAddr) => {
          const showModal = lpModalsOpen[pairAddr];
          if (!showModal) return null;

          // Find the actual LP data from lpHoldings
          let lpToken = lpHoldings.get(pairAddr.toLowerCase());

          // If not found in lpHoldings, search in selectedLiquidityPairs
          if (!lpToken) {
            for (let [
              tokenAddress,
              pairs,
            ] of selectedLiquidityPairs.entries()) {
              const foundPair = pairs.find(
                (p) => p.pairAddress.toLowerCase() === pairAddr.toLowerCase()
              );
              if (foundPair) {
                lpToken = foundPair;
                break;
              }
            }
          }

          if (!lpToken) return null; // Handle case where LP token is not found

          return (
            <LpManageModal
              key={pairAddr}
              tokenSelections={tokenSelections}
              visible={true}
              onClose={() => {
                setLpModalsOpen((prev) => {
                  const newObj = { ...prev };
                  delete newObj[pairAddr];
                  return newObj;
                });
              }}
              lpData={lpToken}
              account={account}
              provider={library.provider} // or library
              bnbPrice={bnbPrice}
              privacyMode={privacyMode}
              refreshData={refreshData}
            />
          );
        })}

        {/* Token Selector Modal */}
        {showModal && (
          <TokenSelectorModal
            tokens={filteredTokens}
            onSelect={handleTokenSelect}
            onClose={handleCloseModal}
            isVisible={showModal}
            setShowModal={setShowModal}
            imageReferences={imageReferences}
          />
        )}

        <Dialog
          visible={showHolderModal}
          onHide={() => setShowHolderModal(false)}
          modal
          style={{ width: "750px", borderRadius: "10px" }}
        >
          <HolderCharts
            holderAddress={holderAddress}
            timeFrame="12h"
            onClose={() => setShowHolderModal(false)}
          />
        </Dialog>

        {/* Removed <Toast ref={toast} /> from primereact */}
      </div>
    );
}

export default React.memo(Wallet);
